import { ref as R, inject as In, h as ge, getCurrentInstance as En, nextTick as Pn, reactive as Rn, defineComponent as $n, createVNode as O, resolveComponent as M, openBlock as v, createBlock as P, withCtx as I, createElementVNode as y, normalizeStyle as Mn, normalizeClass as X, mergeModels as gt, useModel as Dn, createElementBlock as E, createCommentVNode as $, unref as h, computed as mt, watch as Ut, toDisplayString as V, renderSlot as j, withKeys as je, Fragment as et, renderList as zt, mergeProps as me, createTextVNode as Ie, useSlots as qt, normalizeProps as jn, guardReactiveProps as Hn, getCurrentScope as Nn, onScopeDispose as Bn, resolveDynamicComponent as Xt } from "vue";
import { theme as Ln, Affix as Fn, Alert as Gn, Anchor as Vn, AnchorLink as Wn, App as Un, AutoComplete as zn, AutoCompleteOptGroup as qn, AutoCompleteOption as Xn, Avatar as Zn, AvatarGroup as Yn, BackTop as Kn, Badge as Qn, BadgeRibbon as Jn, Breadcrumb as er, BreadcrumbItem as tr, BreadcrumbSeparator as nr, Button as rr, ButtonGroup as or, Calendar as ar, Card as ir, CardGrid as lr, CardMeta as sr, Carousel as ur, Cascader as cr, CheckableTag as dr, Checkbox as fr, CheckboxGroup as pr, Col as hr, Collapse as vr, CollapsePanel as gr, Comment as mr, Compact as br, ConfigProvider as yr, DatePicker as _r, Descriptions as Cr, DescriptionsItem as wr, DirectoryTree as Ar, Divider as xr, Drawer as kr, Dropdown as Sr, DropdownButton as Tr, Empty as Or, Flex as Ir, FloatButton as Er, FloatButtonGroup as Pr, Form as Zt, FormItem as Yt, FormItemRest as Rr, Grid as tt, Image as $r, ImagePreviewGroup as Mr, Input as Kt, InputGroup as Dr, InputNumber as jr, InputPassword as Hr, InputSearch as Nr, Layout as Br, LayoutContent as Lr, LayoutFooter as Fr, LayoutHeader as Gr, LayoutSider as Vr, List as Wr, ListItem as Ur, ListItemMeta as zr, LocaleProvider as qr, Mentions as Xr, MentionsOption as Zr, Menu as Yr, MenuDivider as Kr, MenuItem as Qr, MenuItemGroup as Jr, Modal as eo, MonthPicker as to, PageHeader as no, Pagination as ro, Popconfirm as oo, Popover as Qt, Progress as ao, QRCode as io, QuarterPicker as lo, Radio as so, RadioButton as uo, RadioGroup as co, RangePicker as fo, Rate as po, Result as ho, Row as vo, Segmented as go, Select as mo, SelectOptGroup as bo, SelectOption as yo, Skeleton as _o, SkeletonAvatar as Co, SkeletonButton as wo, SkeletonImage as Ao, SkeletonInput as xo, SkeletonTitle as ko, Slider as So, Space as To, Spin as Oo, Statistic as Io, StatisticCountdown as Eo, Step as Po, Steps as Ro, SubMenu as $o, Switch as Mo, TabPane as Do, Table as jo, TableColumn as Ho, TableColumnGroup as No, TableSummary as Bo, TableSummaryCell as Lo, TableSummaryRow as Fo, Tabs as Go, Tag as Vo, Textarea as Wo, TimePicker as Uo, TimeRangePicker as zo, Timeline as qo, TimelineItem as Xo, Tooltip as Zo, Tour as Yo, Transfer as Ko, Tree as Qo, TreeNode as Jo, TreeSelect as ea, TreeSelectNode as ta, Typography as na, TypographyLink as ra, TypographyParagraph as oa, TypographyText as aa, TypographyTitle as ia, Upload as la, UploadDragger as sa, Watermark as ua, WeekPicker as ca, message as da, notification as fa } from "ant-design-vue";
import { theme as As, ConfigProvider as xs, Grid as ks, notification as Ss } from "ant-design-vue";
function ys() {
  const { useToken: e } = Ln, { token: n } = e(), t = R({});
  function r(o = {}) {
    t.value = {
      ...t.value,
      ...o
    };
  }
  return { tokenValue: t, token: n, updateTheme: r };
}
const pa = {
  ApAffix: Fn,
  ApAlert: Gn,
  ApAnchor: Vn,
  ApAnchorLink: Wn,
  ApApp: Un,
  ApAutoComplete: zn,
  ApAutoCompleteOptGroup: qn,
  ApAutoCompleteOption: Xn,
  ApAvatar: Zn,
  ApAvatarGroup: Yn,
  ApBackTop: Kn,
  ApBadge: Qn,
  ApBadgeRibbon: Jn,
  ApBreadcrumb: er,
  ApBreadcrumbItem: tr,
  ApBreadcrumbSeparator: nr,
  ApButton: rr,
  ApButtonGroup: or,
  ApCalendar: ar,
  ApCard: ir,
  ApCardGrid: lr,
  ApCardMeta: sr,
  ApCarousel: ur,
  ApCascader: cr,
  ApCheckableTag: dr,
  ApCheckbox: fr,
  ApCheckboxGroup: pr,
  ApCol: hr,
  ApCollapse: vr,
  ApCollapsePanel: gr,
  ApComment: mr,
  ApCompact: br,
  ApConfigProvider: yr,
  ApDatePicker: _r,
  ApDescriptions: Cr,
  ApDescriptionsItem: wr,
  ApDirectoryTree: Ar,
  ApDivider: xr,
  ApDrawer: kr,
  ApDropdown: Sr,
  ApDropdownButton: Tr,
  ApEmpty: Or,
  ApFlex: Ir,
  ApFloatButton: Er,
  ApFloatButtonGroup: Pr,
  ApForm: Zt,
  ApFormItem: Yt,
  ApFormItemRest: Rr,
  ApGrid: tt,
  ApImage: $r,
  ApImagePreviewGroup: Mr,
  ApInput: Kt,
  ApInputGroup: Dr,
  ApInputNumber: jr,
  ApInputPassword: Hr,
  ApInputSearch: Nr,
  ApLayout: Br,
  ApLayoutContent: Lr,
  ApLayoutFooter: Fr,
  ApLayoutHeader: Gr,
  ApLayoutSider: Vr,
  ApList: Wr,
  ApListItem: Ur,
  ApListItemMeta: zr,
  ApLocaleProvider: qr,
  ApMentions: Xr,
  ApMentionsOption: Zr,
  ApMenu: Yr,
  ApMenuDivider: Kr,
  ApMenuItem: Qr,
  ApMenuItemGroup: Jr,
  ApModal: eo,
  ApMonthPicker: to,
  ApPageHeader: no,
  ApPagination: ro,
  ApPopconfirm: oo,
  ApPopover: Qt,
  ApProgress: ao,
  ApQRCode: io,
  ApQuarterPicker: lo,
  ApRadio: so,
  ApRadioButton: uo,
  ApRadioGroup: co,
  ApRangePicker: fo,
  ApRate: po,
  ApResult: ho,
  ApRow: vo,
  ApSegmented: go,
  ApSelect: mo,
  ApSelectOptGroup: bo,
  ApSelectOption: yo,
  ApSkeleton: _o,
  ApSkeletonAvatar: Co,
  ApSkeletonButton: wo,
  ApSkeletonImage: Ao,
  ApSkeletonInput: xo,
  ApSkeletonTitle: ko,
  ApSlider: So,
  ApSpace: To,
  ApSpin: Oo,
  ApStatistic: Io,
  ApStatisticCountdown: Eo,
  ApStep: Po,
  ApSteps: Ro,
  ApSubMenu: $o,
  ApSwitch: Mo,
  ApTabPane: Do,
  ApTable: jo,
  ApTableColumn: Ho,
  ApTableColumnGroup: No,
  ApTableSummary: Bo,
  ApTableSummaryCell: Lo,
  ApTableSummaryRow: Fo,
  ApTabs: Go,
  ApTag: Vo,
  ApTextarea: Wo,
  ApTimePicker: Uo,
  ApTimeRangePicker: zo,
  ApTimeline: qo,
  ApTimelineItem: Xo,
  ApTooltip: Zo,
  ApTour: Yo,
  ApTransfer: Ko,
  ApTree: Qo,
  ApTreeNode: Jo,
  ApTreeSelect: ea,
  ApTreeSelectNode: ta,
  ApTypography: na,
  ApTypographyLink: ra,
  ApTypographyParagraph: oa,
  ApTypographyText: aa,
  ApTypographyTitle: ia,
  ApUpload: la,
  ApUploadDragger: sa,
  ApWatermark: ua,
  ApWeekPicker: ca,
  ApMessage: da,
  ApNotification: fa
};
function U(e, n) {
  ha(e) && (e = "100%");
  var t = va(e);
  return e = n === 360 ? e : Math.min(n, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * n), 10) / 100), Math.abs(e - n) < 1e-6 ? 1 : (n === 360 ? e = (e < 0 ? e % n + n : e % n) / parseFloat(String(n)) : e = e % n / parseFloat(String(n)), e);
}
function ha(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function va(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function ga(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function be(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function He(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function ma(e, n, t) {
  return {
    r: U(e, 255) * 255,
    g: U(n, 255) * 255,
    b: U(t, 255) * 255
  };
}
function Ne(e, n, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (n - e) * (6 * t) : t < 1 / 2 ? n : t < 2 / 3 ? e + (n - e) * (2 / 3 - t) * 6 : e;
}
function ba(e, n, t) {
  var r, o, a;
  if (e = U(e, 360), n = U(n, 100), t = U(t, 100), n === 0)
    o = t, a = t, r = t;
  else {
    var i = t < 0.5 ? t * (1 + n) : t + n - t * n, l = 2 * t - i;
    r = Ne(l, i, e + 1 / 3), o = Ne(l, i, e), a = Ne(l, i, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: a * 255 };
}
function ya(e, n, t) {
  e = U(e, 255), n = U(n, 255), t = U(t, 255);
  var r = Math.max(e, n, t), o = Math.min(e, n, t), a = 0, i = r, l = r - o, u = r === 0 ? 0 : l / r;
  if (r === o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (n - t) / l + (n < t ? 6 : 0);
        break;
      case n:
        a = (t - e) / l + 2;
        break;
      case t:
        a = (e - n) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: u, v: i };
}
function _a(e, n, t) {
  e = U(e, 360) * 6, n = U(n, 100), t = U(t, 100);
  var r = Math.floor(e), o = e - r, a = t * (1 - n), i = t * (1 - o * n), l = t * (1 - (1 - o) * n), u = r % 6, c = [t, i, a, a, l, t][u], d = [l, t, t, i, a, a][u], s = [a, a, l, t, t, i][u];
  return { r: c * 255, g: d * 255, b: s * 255 };
}
function Ca(e, n, t, r) {
  var o = [
    He(Math.round(e).toString(16)),
    He(Math.round(n).toString(16)),
    He(Math.round(t).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function bt(e) {
  return G(e) / 255;
}
function G(e) {
  return parseInt(e, 16);
}
var yt = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function ue(e) {
  var n = { r: 0, g: 0, b: 0 }, t = 1, r = null, o = null, a = null, i = !1, l = !1;
  return typeof e == "string" && (e = xa(e)), typeof e == "object" && (Z(e.r) && Z(e.g) && Z(e.b) ? (n = ma(e.r, e.g, e.b), i = !0, l = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Z(e.h) && Z(e.s) && Z(e.v) ? (r = be(e.s), o = be(e.v), n = _a(e.h, r, o), i = !0, l = "hsv") : Z(e.h) && Z(e.s) && Z(e.l) && (r = be(e.s), a = be(e.l), n = ba(e.h, r, a), i = !0, l = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = ga(t), {
    ok: i,
    format: e.format || l,
    r: Math.min(255, Math.max(n.r, 0)),
    g: Math.min(255, Math.max(n.g, 0)),
    b: Math.min(255, Math.max(n.b, 0)),
    a: t
  };
}
var wa = "[-\\+]?\\d+%?", Aa = "[-\\+]?\\d*\\.\\d+%?", Y = "(?:".concat(Aa, ")|(?:").concat(wa, ")"), Be = "[\\s|\\(]+(".concat(Y, ")[,|\\s]+(").concat(Y, ")[,|\\s]+(").concat(Y, ")\\s*\\)?"), Le = "[\\s|\\(]+(".concat(Y, ")[,|\\s]+(").concat(Y, ")[,|\\s]+(").concat(Y, ")[,|\\s]+(").concat(Y, ")\\s*\\)?"), q = {
  CSS_UNIT: new RegExp(Y),
  rgb: new RegExp("rgb" + Be),
  rgba: new RegExp("rgba" + Le),
  hsl: new RegExp("hsl" + Be),
  hsla: new RegExp("hsla" + Le),
  hsv: new RegExp("hsv" + Be),
  hsva: new RegExp("hsva" + Le),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function xa(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var n = !1;
  if (yt[e])
    e = yt[e], n = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = q.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = q.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = q.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = q.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = q.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = q.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = q.hex8.exec(e), t ? {
    r: G(t[1]),
    g: G(t[2]),
    b: G(t[3]),
    a: bt(t[4]),
    format: n ? "name" : "hex8"
  } : (t = q.hex6.exec(e), t ? {
    r: G(t[1]),
    g: G(t[2]),
    b: G(t[3]),
    format: n ? "name" : "hex"
  } : (t = q.hex4.exec(e), t ? {
    r: G(t[1] + t[1]),
    g: G(t[2] + t[2]),
    b: G(t[3] + t[3]),
    a: bt(t[4] + t[4]),
    format: n ? "name" : "hex8"
  } : (t = q.hex3.exec(e), t ? {
    r: G(t[1] + t[1]),
    g: G(t[2] + t[2]),
    b: G(t[3] + t[3]),
    format: n ? "name" : "hex"
  } : !1)))))))));
}
function Z(e) {
  return !!q.CSS_UNIT.exec(String(e));
}
var ye = 2, _t = 0.16, ka = 0.05, Sa = 0.05, Ta = 0.15, Jt = 5, en = 4, Oa = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function Ct(e) {
  var n = e.r, t = e.g, r = e.b, o = ya(n, t, r);
  return {
    h: o.h * 360,
    s: o.s,
    v: o.v
  };
}
function _e(e) {
  var n = e.r, t = e.g, r = e.b;
  return "#".concat(Ca(n, t, r, !1));
}
function Ia(e, n, t) {
  var r = t / 100, o = {
    r: (n.r - e.r) * r + e.r,
    g: (n.g - e.g) * r + e.g,
    b: (n.b - e.b) * r + e.b
  };
  return o;
}
function wt(e, n, t) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = t ? Math.round(e.h) - ye * n : Math.round(e.h) + ye * n : r = t ? Math.round(e.h) + ye * n : Math.round(e.h) - ye * n, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function At(e, n, t) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return t ? r = e.s - _t * n : n === en ? r = e.s + _t : r = e.s + ka * n, r > 1 && (r = 1), t && n === Jt && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function xt(e, n, t) {
  var r;
  return t ? r = e.v + Sa * n : r = e.v - Ta * n, r > 1 && (r = 1), Number(r.toFixed(2));
}
function ze(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = [], r = ue(e), o = Jt; o > 0; o -= 1) {
    var a = Ct(r), i = _e(ue({
      h: wt(a, o, !0),
      s: At(a, o, !0),
      v: xt(a, o, !0)
    }));
    t.push(i);
  }
  t.push(_e(r));
  for (var l = 1; l <= en; l += 1) {
    var u = Ct(r), c = _e(ue({
      h: wt(u, l),
      s: At(u, l),
      v: xt(u, l)
    }));
    t.push(c);
  }
  return n.theme === "dark" ? Oa.map(function(d) {
    var s = d.index, f = d.opacity, p = _e(Ia(ue(n.backgroundColor || "#141414"), ue(t[s]), f * 100));
    return p;
  }) : t;
}
var Fe = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Ae = {}, Ge = {};
Object.keys(Fe).forEach(function(e) {
  Ae[e] = ze(Fe[e]), Ae[e].primary = Ae[e][5], Ge[e] = ze(Fe[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), Ge[e].primary = Ge[e][5];
});
var Ea = Ae.blue, Pa = Symbol("iconContext"), tn = function() {
  return In(Pa, {
    prefixCls: R("anticon"),
    rootClassName: R(""),
    csp: R()
  });
};
function nt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Ra(e, n) {
  return e && e.contains ? e.contains(n) : !1;
}
var kt = "data-vc-order", $a = "vc-icon-key", qe = /* @__PURE__ */ new Map();
function nn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.mark;
  return n ? n.startsWith("data-") ? n : "data-".concat(n) : $a;
}
function rt(e) {
  if (e.attachTo)
    return e.attachTo;
  var n = document.querySelector("head");
  return n || document.body;
}
function Ma(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function rn(e) {
  return Array.from((qe.get(e) || e).children).filter(function(n) {
    return n.tagName === "STYLE";
  });
}
function on(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!nt())
    return null;
  var t = n.csp, r = n.prepend, o = document.createElement("style");
  o.setAttribute(kt, Ma(r)), t && t.nonce && (o.nonce = t.nonce), o.innerHTML = e;
  var a = rt(n), i = a.firstChild;
  if (r) {
    if (r === "queue") {
      var l = rn(a).filter(function(u) {
        return ["prepend", "prependQueue"].includes(u.getAttribute(kt));
      });
      if (l.length)
        return a.insertBefore(o, l[l.length - 1].nextSibling), o;
    }
    a.insertBefore(o, i);
  } else
    a.appendChild(o);
  return o;
}
function Da(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = rt(n);
  return rn(t).find(function(r) {
    return r.getAttribute(nn(n)) === e;
  });
}
function ja(e, n) {
  var t = qe.get(e);
  if (!t || !Ra(document, t)) {
    var r = on("", n), o = r.parentNode;
    qe.set(e, o), e.removeChild(r);
  }
}
function Ha(e, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = rt(t);
  ja(r, t);
  var o = Da(n, t);
  if (o)
    return t.csp && t.csp.nonce && o.nonce !== t.csp.nonce && (o.nonce = t.csp.nonce), o.innerHTML !== e && (o.innerHTML = e), o;
  var a = on(e, t);
  return a.setAttribute(nn(t), n), a;
}
function St(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      Na(e, o, t[o]);
    });
  }
  return e;
}
function Na(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function Ba(e, n) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error("Warning: ".concat(n));
}
function La(e, n) {
  Ba(e, "[@ant-design/icons-vue] ".concat(n));
}
function Tt(e) {
  return typeof e == "object" && typeof e.name == "string" && typeof e.theme == "string" && (typeof e.icon == "object" || typeof e.icon == "function");
}
function Xe(e, n, t) {
  return t ? ge(e.tag, St({
    key: n
  }, t, e.attrs), (e.children || []).map(function(r, o) {
    return Xe(r, "".concat(n, "-").concat(e.tag, "-").concat(o));
  })) : ge(e.tag, St({
    key: n
  }, e.attrs), (e.children || []).map(function(r, o) {
    return Xe(r, "".concat(n, "-").concat(e.tag, "-").concat(o));
  }));
}
function an(e) {
  return ze(e)[0];
}
function ln(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Fa = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
function sn(e) {
  return e && e.getRootNode && e.getRootNode();
}
function Ga(e) {
  return nt() ? sn(e) instanceof ShadowRoot : !1;
}
function Va(e) {
  return Ga(e) ? sn(e) : null;
}
var Wa = function() {
  var n = tn(), t = n.prefixCls, r = n.csp, o = En(), a = Fa;
  t && (a = a.replace(/anticon/g, t.value)), Pn(function() {
    if (nt()) {
      var i = o.vnode.el, l = Va(i);
      Ha(a, "@ant-design-vue-icons", {
        prepend: !0,
        csp: r.value,
        attachTo: l
      });
    }
  });
}, Ua = ["icon", "primaryColor", "secondaryColor"];
function za(e, n) {
  if (e == null)
    return {};
  var t = qa(e, n), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function qa(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function xe(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      Xa(e, o, t[o]);
    });
  }
  return e;
}
function Xa(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var pe = Rn({
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
});
function Za(e) {
  var n = e.primaryColor, t = e.secondaryColor;
  pe.primaryColor = n, pe.secondaryColor = t || an(n), pe.calculated = !!t;
}
function Ya() {
  return xe({}, pe);
}
var le = function(n, t) {
  var r = xe({}, n, t.attrs), o = r.icon, a = r.primaryColor, i = r.secondaryColor, l = za(r, Ua), u = pe;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: i || an(a)
  }), La(Tt(o), "icon should be icon definiton, but got ".concat(o)), !Tt(o))
    return null;
  var c = o;
  return c && typeof c.icon == "function" && (c = xe({}, c, {
    icon: c.icon(u.primaryColor, u.secondaryColor)
  })), Xe(c.icon, "svg-".concat(c.name), xe({}, l, {
    "data-icon": c.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }));
};
le.props = {
  icon: Object,
  primaryColor: String,
  secondaryColor: String,
  focusable: String
};
le.inheritAttrs = !1;
le.displayName = "IconBase";
le.getTwoToneColors = Ya;
le.setTwoToneColors = Za;
const ot = le;
function Ka(e, n) {
  return ti(e) || ei(e, n) || Ja(e, n) || Qa();
}
function Qa() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ja(e, n) {
  if (e) {
    if (typeof e == "string")
      return Ot(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Ot(e, n);
  }
}
function Ot(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function ei(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], o = !0, a = !1, i, l;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (r.push(i.value), !(n && r.length === n)); o = !0)
        ;
    } catch (u) {
      a = !0, l = u;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a)
          throw l;
      }
    }
    return r;
  }
}
function ti(e) {
  if (Array.isArray(e))
    return e;
}
function un(e) {
  var n = ln(e), t = Ka(n, 2), r = t[0], o = t[1];
  return ot.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function ni() {
  var e = ot.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var ri = $n({
  name: "InsertStyles",
  setup: function() {
    return Wa(), function() {
      return null;
    };
  }
}), oi = ["class", "icon", "spin", "rotate", "tabindex", "twoToneColor", "onClick"];
function ai(e, n) {
  return ui(e) || si(e, n) || li(e, n) || ii();
}
function ii() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function li(e, n) {
  if (e) {
    if (typeof e == "string")
      return It(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return It(e, n);
  }
}
function It(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function si(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], o = !0, a = !1, i, l;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (r.push(i.value), !(n && r.length === n)); o = !0)
        ;
    } catch (u) {
      a = !0, l = u;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a)
          throw l;
      }
    }
    return r;
  }
}
function ui(e) {
  if (Array.isArray(e))
    return e;
}
function Et(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      de(e, o, t[o]);
    });
  }
  return e;
}
function de(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function ci(e, n) {
  if (e == null)
    return {};
  var t = di(e, n), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function di(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
un(Ea.primary);
var se = function(n, t) {
  var r, o = Et({}, n, t.attrs), a = o.class, i = o.icon, l = o.spin, u = o.rotate, c = o.tabindex, d = o.twoToneColor, s = o.onClick, f = ci(o, oi), p = tn(), g = p.prefixCls, m = p.rootClassName, _ = (r = {}, de(r, m.value, !!m.value), de(r, g.value, !0), de(r, "".concat(g.value, "-").concat(i.name), !!i.name), de(r, "".concat(g.value, "-spin"), !!l || i.name === "loading"), r), A = c;
  A === void 0 && s && (A = -1);
  var w = u ? {
    msTransform: "rotate(".concat(u, "deg)"),
    transform: "rotate(".concat(u, "deg)")
  } : void 0, F = ln(d), D = ai(F, 2), k = D[0], b = D[1];
  return O("span", Et({
    role: "img",
    "aria-label": i.name
  }, f, {
    onClick: s,
    class: [_, a],
    tabindex: A
  }), [O(ot, {
    icon: i,
    primaryColor: k,
    secondaryColor: b,
    style: w
  }, null), O(ri, null, null)]);
};
se.props = {
  spin: Boolean,
  rotate: Number,
  icon: Object,
  twoToneColor: [String, Array]
};
se.displayName = "AntdIcon";
se.inheritAttrs = !1;
se.getTwoToneColor = ni;
se.setTwoToneColor = un;
const Ee = se;
var fi = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const pi = fi;
function Pt(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      hi(e, o, t[o]);
    });
  }
  return e;
}
function hi(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var at = function(n, t) {
  var r = Pt({}, n, t.attrs);
  return O(Ee, Pt({}, r, {
    icon: pi
  }), null);
};
at.displayName = "CloseOutlined";
at.inheritAttrs = !1;
const vi = at;
var gi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const mi = gi;
function Rt(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      bi(e, o, t[o]);
    });
  }
  return e;
}
function bi(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var it = function(n, t) {
  var r = Rt({}, n, t.attrs);
  return O(Ee, Rt({}, r, {
    icon: mi
  }), null);
};
it.displayName = "DeleteOutlined";
it.inheritAttrs = !1;
const yi = it;
var _i = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, name: "menu", theme: "outlined" };
const Ci = _i;
function $t(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      wi(e, o, t[o]);
    });
  }
  return e;
}
function wi(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var lt = function(n, t) {
  var r = $t({}, n, t.attrs);
  return O(Ee, $t({}, r, {
    icon: Ci
  }), null);
};
lt.displayName = "MenuOutlined";
lt.inheritAttrs = !1;
const Ai = lt;
var xi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const ki = xi;
function Mt(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? Object(arguments[n]) : {}, r = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    }))), r.forEach(function(o) {
      Si(e, o, t[o]);
    });
  }
  return e;
}
function Si(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var st = function(n, t) {
  var r = Mt({}, n, t.attrs);
  return O(Ee, Mt({}, r, {
    icon: ki
  }), null);
};
st.displayName = "PlusOutlined";
st.inheritAttrs = !1;
const Ti = st;
/*!
 * iro.js v5.5.2
 * 2016-2021 James Daniel
 * Licensed under MPL 2.0
 * github.com/jaames/iro.js
 */
var T, Se, cn, Ze, dn, Q = {}, ut = [], Oi = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i;
function K(e, n) {
  for (var t in n)
    e[t] = n[t];
  return e;
}
function fn(e) {
  var n = e.parentNode;
  n && n.removeChild(e);
}
function C(e, n, t) {
  var r, o, a, i, l = arguments;
  if (n = K({}, n), arguments.length > 3)
    for (t = [t], r = 3; r < arguments.length; r++)
      t.push(l[r]);
  if (t != null && (n.children = t), e != null && e.defaultProps != null)
    for (o in e.defaultProps)
      n[o] === void 0 && (n[o] = e.defaultProps[o]);
  return i = n.key, (a = n.ref) != null && delete n.ref, i != null && delete n.key, Ye(e, n, i, a);
}
function Ye(e, n, t, r) {
  var o = { type: e, props: n, key: t, ref: r, __k: null, __p: null, __b: 0, __e: null, l: null, __c: null, constructor: void 0 };
  return T.vnode && T.vnode(o), o;
}
function Pe(e) {
  return e.children;
}
function Ii(e) {
  if (e == null || typeof e == "boolean")
    return null;
  if (typeof e == "string" || typeof e == "number")
    return Ye(null, e, null, null);
  if (e.__e != null || e.__c != null) {
    var n = Ye(e.type, e.props, e.key, null);
    return n.__e = e.__e, n;
  }
  return e;
}
function ie(e, n) {
  this.props = e, this.context = n;
}
function Te(e, n) {
  if (n == null)
    return e.__p ? Te(e.__p, e.__p.__k.indexOf(e) + 1) : null;
  for (var t; n < e.__k.length; n++)
    if ((t = e.__k[n]) != null && t.__e != null)
      return t.__e;
  return typeof e.type == "function" ? Te(e) : null;
}
function pn(e) {
  var n, t;
  if ((e = e.__p) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, n = 0; n < e.__k.length; n++)
      if ((t = e.__k[n]) != null && t.__e != null) {
        e.__e = e.__c.base = t.__e;
        break;
      }
    return pn(e);
  }
}
function Ve(e) {
  (!e.__d && (e.__d = !0) && Se.push(e) === 1 || Ze !== T.debounceRendering) && (Ze = T.debounceRendering, (T.debounceRendering || cn)(Ei));
}
function Ei() {
  var e, n, t, r, o, a, i, l;
  for (Se.sort(function(u, c) {
    return c.__v.__b - u.__v.__b;
  }); e = Se.pop(); )
    e.__d && (t = void 0, r = void 0, a = (o = (n = e).__v).__e, i = n.__P, l = n.u, n.u = !1, i && (t = [], r = dt(i, o, K({}, o), n.__n, i.ownerSVGElement !== void 0, null, t, l, a ?? Te(o)), vn(t, o), r != a && pn(o)));
}
function hn(e, n, t, r, o, a, i, l, u) {
  var c, d, s, f, p, g, m, _ = t && t.__k || ut, A = _.length;
  if (l == Q && (l = a != null ? a[0] : A ? Te(t, 0) : null), c = 0, n.__k = ct(n.__k, function(w) {
    if (w != null) {
      if (w.__p = n, w.__b = n.__b + 1, (s = _[c]) === null || s && w.key == s.key && w.type === s.type)
        _[c] = void 0;
      else
        for (d = 0; d < A; d++) {
          if ((s = _[d]) && w.key == s.key && w.type === s.type) {
            _[d] = void 0;
            break;
          }
          s = null;
        }
      if (f = dt(e, w, s = s || Q, r, o, a, i, null, l, u), (d = w.ref) && s.ref != d && (m || (m = [])).push(d, w.__c || f, w), f != null) {
        if (g == null && (g = f), w.l != null)
          f = w.l, w.l = null;
        else if (a == s || f != l || f.parentNode == null) {
          e:
            if (l == null || l.parentNode !== e)
              e.appendChild(f);
            else {
              for (p = l, d = 0; (p = p.nextSibling) && d < A; d += 2)
                if (p == f)
                  break e;
              e.insertBefore(f, l);
            }
          n.type == "option" && (e.value = "");
        }
        l = f.nextSibling, typeof n.type == "function" && (n.l = f);
      }
    }
    return c++, w;
  }), n.__e = g, a != null && typeof n.type != "function")
    for (c = a.length; c--; )
      a[c] != null && fn(a[c]);
  for (c = A; c--; )
    _[c] != null && mn(_[c], _[c]);
  if (m)
    for (c = 0; c < m.length; c++)
      gn(m[c], m[++c], m[++c]);
}
function ct(e, n, t) {
  if (t == null && (t = []), e == null || typeof e == "boolean")
    n && t.push(n(null));
  else if (Array.isArray(e))
    for (var r = 0; r < e.length; r++)
      ct(e[r], n, t);
  else
    t.push(n ? n(Ii(e)) : e);
  return t;
}
function Pi(e, n, t, r, o) {
  var a;
  for (a in t)
    a in n || jt(e, a, null, t[a], r);
  for (a in n)
    o && typeof n[a] != "function" || a === "value" || a === "checked" || t[a] === n[a] || jt(e, a, n[a], t[a], r);
}
function Dt(e, n, t) {
  n[0] === "-" ? e.setProperty(n, t) : e[n] = typeof t == "number" && Oi.test(n) === !1 ? t + "px" : t ?? "";
}
function jt(e, n, t, r, o) {
  var a, i, l, u, c;
  if (!((n = o ? n === "className" ? "class" : n : n === "class" ? "className" : n) === "key" || n === "children"))
    if (n === "style")
      if (a = e.style, typeof t == "string")
        a.cssText = t;
      else {
        if (typeof r == "string" && (a.cssText = "", r = null), r)
          for (i in r)
            t && i in t || Dt(a, i, "");
        if (t)
          for (l in t)
            r && t[l] === r[l] || Dt(a, l, t[l]);
      }
    else
      n[0] === "o" && n[1] === "n" ? (u = n !== (n = n.replace(/Capture$/, "")), c = n.toLowerCase(), n = (c in e ? c : n).slice(2), t ? (r || e.addEventListener(n, Ht, u), (e.t || (e.t = {}))[n] = t) : e.removeEventListener(n, Ht, u)) : n !== "list" && n !== "tagName" && n !== "form" && !o && n in e ? e[n] = t ?? "" : typeof t != "function" && n !== "dangerouslySetInnerHTML" && (n !== (n = n.replace(/^xlink:?/, "")) ? t == null || t === !1 ? e.removeAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase()) : e.setAttributeNS("http://www.w3.org/1999/xlink", n.toLowerCase(), t) : t == null || t === !1 ? e.removeAttribute(n) : e.setAttribute(n, t));
}
function Ht(e) {
  return this.t[e.type](T.event ? T.event(e) : e);
}
function dt(e, n, t, r, o, a, i, l, u, c) {
  var d, s, f, p, g, m, _, A, w, F, D = n.type;
  if (n.constructor !== void 0)
    return null;
  (d = T.__b) && d(n);
  try {
    e:
      if (typeof D == "function") {
        if (A = n.props, w = (d = D.contextType) && r[d.__c], F = d ? w ? w.props.value : d.__p : r, t.__c ? _ = (s = n.__c = t.__c).__p = s.__E : ("prototype" in D && D.prototype.render ? n.__c = s = new D(A, F) : (n.__c = s = new ie(A, F), s.constructor = D, s.render = $i), w && w.sub(s), s.props = A, s.state || (s.state = {}), s.context = F, s.__n = r, f = s.__d = !0, s.__h = []), s.__s == null && (s.__s = s.state), D.getDerivedStateFromProps != null && K(s.__s == s.state ? s.__s = K({}, s.__s) : s.__s, D.getDerivedStateFromProps(A, s.__s)), f)
          D.getDerivedStateFromProps == null && s.componentWillMount != null && s.componentWillMount(), s.componentDidMount != null && i.push(s);
        else {
          if (D.getDerivedStateFromProps == null && l == null && s.componentWillReceiveProps != null && s.componentWillReceiveProps(A, F), !l && s.shouldComponentUpdate != null && s.shouldComponentUpdate(A, s.__s, F) === !1) {
            for (s.props = A, s.state = s.__s, s.__d = !1, s.__v = n, n.__e = u != null ? u !== t.__e ? u : t.__e : null, n.__k = t.__k, d = 0; d < n.__k.length; d++)
              n.__k[d] && (n.__k[d].__p = n);
            break e;
          }
          s.componentWillUpdate != null && s.componentWillUpdate(A, s.__s, F);
        }
        for (p = s.props, g = s.state, s.context = F, s.props = A, s.state = s.__s, (d = T.__r) && d(n), s.__d = !1, s.__v = n, s.__P = e, d = s.render(s.props, s.state, s.context), n.__k = ct(d != null && d.type == Pe && d.key == null ? d.props.children : d), s.getChildContext != null && (r = K(K({}, r), s.getChildContext())), f || s.getSnapshotBeforeUpdate == null || (m = s.getSnapshotBeforeUpdate(p, g)), hn(e, n, t, r, o, a, i, u, c), s.base = n.__e; d = s.__h.pop(); )
          s.__s && (s.state = s.__s), d.call(s);
        f || p == null || s.componentDidUpdate == null || s.componentDidUpdate(p, g, m), _ && (s.__E = s.__p = null);
      } else
        n.__e = Ri(t.__e, n, t, r, o, a, i, c);
    (d = T.diffed) && d(n);
  } catch (k) {
    T.__e(k, n, t);
  }
  return n.__e;
}
function vn(e, n) {
  for (var t; t = e.pop(); )
    try {
      t.componentDidMount();
    } catch (r) {
      T.__e(r, t.__v);
    }
  T.__c && T.__c(n);
}
function Ri(e, n, t, r, o, a, i, l) {
  var u, c, d, s, f = t.props, p = n.props;
  if (o = n.type === "svg" || o, e == null && a != null) {
    for (u = 0; u < a.length; u++)
      if ((c = a[u]) != null && (n.type === null ? c.nodeType === 3 : c.localName === n.type)) {
        e = c, a[u] = null;
        break;
      }
  }
  if (e == null) {
    if (n.type === null)
      return document.createTextNode(p);
    e = o ? document.createElementNS("http://www.w3.org/2000/svg", n.type) : document.createElement(n.type), a = null;
  }
  return n.type === null ? f !== p && (a != null && (a[a.indexOf(e)] = null), e.data = p) : n !== t && (a != null && (a = ut.slice.call(e.childNodes)), d = (f = t.props || Q).dangerouslySetInnerHTML, s = p.dangerouslySetInnerHTML, l || (s || d) && (s && d && s.__html == d.__html || (e.innerHTML = s && s.__html || "")), Pi(e, p, f, o, l), n.__k = n.props.children, s || hn(e, n, t, r, n.type !== "foreignObject" && o, a, i, Q, l), l || ("value" in p && p.value !== void 0 && p.value !== e.value && (e.value = p.value == null ? "" : p.value), "checked" in p && p.checked !== void 0 && p.checked !== e.checked && (e.checked = p.checked))), e;
}
function gn(e, n, t) {
  try {
    typeof e == "function" ? e(n) : e.current = n;
  } catch (r) {
    T.__e(r, t);
  }
}
function mn(e, n, t) {
  var r, o, a;
  if (T.unmount && T.unmount(e), (r = e.ref) && gn(r, null, n), t || typeof e.type == "function" || (t = (o = e.__e) != null), e.__e = e.l = null, (r = e.__c) != null) {
    if (r.componentWillUnmount)
      try {
        r.componentWillUnmount();
      } catch (i) {
        T.__e(i, n);
      }
    r.base = r.__P = null;
  }
  if (r = e.__k)
    for (a = 0; a < r.length; a++)
      r[a] && mn(r[a], n, t);
  o != null && fn(o);
}
function $i(e, n, t) {
  return this.constructor(e, t);
}
function Mi(e, n, t) {
  var r, o, a;
  T.__p && T.__p(e, n), o = (r = t === dn) ? null : t && t.__k || n.__k, e = C(Pe, null, [e]), a = [], dt(n, r ? n.__k = e : (t || n).__k = e, o || Q, Q, n.ownerSVGElement !== void 0, t && !r ? [t] : o ? null : ut.slice.call(n.childNodes), a, !1, t || Q, r), vn(a, e);
}
T = {}, ie.prototype.setState = function(e, n) {
  var t = this.__s !== this.state && this.__s || (this.__s = K({}, this.state));
  (typeof e != "function" || (e = e(t, this.props))) && K(t, e), e != null && this.__v && (this.u = !1, n && this.__h.push(n), Ve(this));
}, ie.prototype.forceUpdate = function(e) {
  this.__v && (e && this.__h.push(e), this.u = !0, Ve(this));
}, ie.prototype.render = Pe, Se = [], cn = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Ze = T.debounceRendering, T.__e = function(e, n, t) {
  for (var r; n = n.__p; )
    if ((r = n.__c) && !r.__p)
      try {
        if (r.constructor && r.constructor.getDerivedStateFromError != null)
          r.setState(r.constructor.getDerivedStateFromError(e));
        else {
          if (r.componentDidCatch == null)
            continue;
          r.componentDidCatch(e);
        }
        return Ve(r.__E = r);
      } catch (o) {
        e = o;
      }
  throw e;
}, dn = Q;
function Nt(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Di(e, n, t) {
  return n && Nt(e.prototype, n), t && Nt(e, t), e;
}
function L() {
  return L = Object.assign || function(e) {
    for (var n = arguments, t = 1; t < arguments.length; t++) {
      var r = n[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, L.apply(this, arguments);
}
var ji = "[-\\+]?\\d+%?", Hi = "[-\\+]?\\d*\\.\\d+%?", ee = "(?:" + Hi + ")|(?:" + ji + ")", bn = "[\\s|\\(]+(" + ee + ")[,|\\s]+(" + ee + ")[,|\\s]+(" + ee + ")\\s*\\)?", yn = "[\\s|\\(]+(" + ee + ")[,|\\s]+(" + ee + ")[,|\\s]+(" + ee + ")[,|\\s]+(" + ee + ")\\s*\\)?", Ni = new RegExp("rgb" + bn), Bi = new RegExp("rgba" + yn), Li = new RegExp("hsl" + bn), Fi = new RegExp("hsla" + yn), Re = "^(?:#?|0x?)", te = "([0-9a-fA-F]{1})", ne = "([0-9a-fA-F]{2})", Gi = new RegExp(Re + te + te + te + "$"), Vi = new RegExp(Re + te + te + te + te + "$"), Wi = new RegExp(Re + ne + ne + ne + "$"), Ui = new RegExp(Re + ne + ne + ne + ne + "$"), zi = 2e3, qi = 4e4, Ce = Math.log, oe = Math.round, ce = Math.floor;
function W(e, n, t) {
  return Math.min(Math.max(e, n), t);
}
function N(e, n) {
  var t = e.indexOf("%") > -1, r = parseFloat(e);
  return t ? n / 100 * r : r;
}
function B(e) {
  return parseInt(e, 16);
}
function J(e) {
  return e.toString(16).padStart(2, "0");
}
var ae = /* @__PURE__ */ function() {
  function e(t, r) {
    this.$ = {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    }, t && this.set(t), this.onChange = r, this.initialValue = L({}, this.$);
  }
  var n = e.prototype;
  return n.set = function(r) {
    if (typeof r == "string")
      /^(?:#?|0x?)[0-9a-fA-F]{3,8}$/.test(r) ? this.hexString = r : /^rgba?/.test(r) ? this.rgbString = r : /^hsla?/.test(r) && (this.hslString = r);
    else if (typeof r == "object")
      r instanceof e ? this.hsva = r.hsva : "r" in r && "g" in r && "b" in r ? this.rgb = r : "h" in r && "s" in r && "v" in r ? this.hsv = r : "h" in r && "s" in r && "l" in r ? this.hsl = r : "kelvin" in r && (this.kelvin = r.kelvin);
    else
      throw new Error("Invalid color value");
  }, n.setChannel = function(r, o, a) {
    var i;
    this[r] = L({}, this[r], (i = {}, i[o] = a, i));
  }, n.reset = function() {
    this.hsva = this.initialValue;
  }, n.clone = function() {
    return new e(this);
  }, n.unbind = function() {
    this.onChange = void 0;
  }, e.hsvToRgb = function(r) {
    var o = r.h / 60, a = r.s / 100, i = r.v / 100, l = ce(o), u = o - l, c = i * (1 - a), d = i * (1 - u * a), s = i * (1 - (1 - u) * a), f = l % 6, p = [i, d, c, c, s, i][f], g = [s, i, i, d, c, c][f], m = [c, c, s, i, i, d][f];
    return {
      r: W(p * 255, 0, 255),
      g: W(g * 255, 0, 255),
      b: W(m * 255, 0, 255)
    };
  }, e.rgbToHsv = function(r) {
    var o = r.r / 255, a = r.g / 255, i = r.b / 255, l = Math.max(o, a, i), u = Math.min(o, a, i), c = l - u, d = 0, s = l, f = l === 0 ? 0 : c / l;
    switch (l) {
      case u:
        d = 0;
        break;
      case o:
        d = (a - i) / c + (a < i ? 6 : 0);
        break;
      case a:
        d = (i - o) / c + 2;
        break;
      case i:
        d = (o - a) / c + 4;
        break;
    }
    return {
      h: d * 60 % 360,
      s: W(f * 100, 0, 100),
      v: W(s * 100, 0, 100)
    };
  }, e.hsvToHsl = function(r) {
    var o = r.s / 100, a = r.v / 100, i = (2 - o) * a, l = i <= 1 ? i : 2 - i, u = l < 1e-9 ? 0 : o * a / l;
    return {
      h: r.h,
      s: W(u * 100, 0, 100),
      l: W(i * 50, 0, 100)
    };
  }, e.hslToHsv = function(r) {
    var o = r.l * 2, a = r.s * (o <= 100 ? o : 200 - o) / 100, i = o + a < 1e-9 ? 0 : 2 * a / (o + a);
    return {
      h: r.h,
      s: W(i * 100, 0, 100),
      v: W((o + a) / 2, 0, 100)
    };
  }, e.kelvinToRgb = function(r) {
    var o = r / 100, a, i, l;
    return o < 66 ? (a = 255, i = -155.25485562709179 - 0.44596950469579133 * (i = o - 2) + 104.49216199393888 * Ce(i), l = o < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (l = o - 10) + 115.67994401066147 * Ce(l)) : (a = 351.97690566805693 + 0.114206453784165 * (a = o - 55) - 40.25366309332127 * Ce(a), i = 325.4494125711974 + 0.07943456536662342 * (i = o - 50) - 28.0852963507957 * Ce(i), l = 255), {
      r: W(ce(a), 0, 255),
      g: W(ce(i), 0, 255),
      b: W(ce(l), 0, 255)
    };
  }, e.rgbToKelvin = function(r) {
    for (var o = r.r, a = r.b, i = 0.4, l = zi, u = qi, c; u - l > i; ) {
      c = (u + l) * 0.5;
      var d = e.kelvinToRgb(c);
      d.b / d.r >= a / o ? u = c : l = c;
    }
    return c;
  }, Di(e, [{
    key: "hsv",
    get: function() {
      var r = this.$;
      return {
        h: r.h,
        s: r.s,
        v: r.v
      };
    },
    set: function(r) {
      var o = this.$;
      if (r = L({}, o, r), this.onChange) {
        var a = {
          h: !1,
          v: !1,
          s: !1,
          a: !1
        };
        for (var i in o)
          a[i] = r[i] != o[i];
        this.$ = r, (a.h || a.s || a.v || a.a) && this.onChange(this, a);
      } else
        this.$ = r;
    }
  }, {
    key: "hsva",
    get: function() {
      return L({}, this.$);
    },
    set: function(r) {
      this.hsv = r;
    }
  }, {
    key: "hue",
    get: function() {
      return this.$.h;
    },
    set: function(r) {
      this.hsv = {
        h: r
      };
    }
  }, {
    key: "saturation",
    get: function() {
      return this.$.s;
    },
    set: function(r) {
      this.hsv = {
        s: r
      };
    }
  }, {
    key: "value",
    get: function() {
      return this.$.v;
    },
    set: function(r) {
      this.hsv = {
        v: r
      };
    }
  }, {
    key: "alpha",
    get: function() {
      return this.$.a;
    },
    set: function(r) {
      this.hsv = L({}, this.hsv, {
        a: r
      });
    }
  }, {
    key: "kelvin",
    get: function() {
      return e.rgbToKelvin(this.rgb);
    },
    set: function(r) {
      this.rgb = e.kelvinToRgb(r);
    }
  }, {
    key: "red",
    get: function() {
      var r = this.rgb;
      return r.r;
    },
    set: function(r) {
      this.rgb = L({}, this.rgb, {
        r
      });
    }
  }, {
    key: "green",
    get: function() {
      var r = this.rgb;
      return r.g;
    },
    set: function(r) {
      this.rgb = L({}, this.rgb, {
        g: r
      });
    }
  }, {
    key: "blue",
    get: function() {
      var r = this.rgb;
      return r.b;
    },
    set: function(r) {
      this.rgb = L({}, this.rgb, {
        b: r
      });
    }
  }, {
    key: "rgb",
    get: function() {
      var r = e.hsvToRgb(this.$), o = r.r, a = r.g, i = r.b;
      return {
        r: oe(o),
        g: oe(a),
        b: oe(i)
      };
    },
    set: function(r) {
      this.hsv = L({}, e.rgbToHsv(r), {
        a: r.a === void 0 ? 1 : r.a
      });
    }
  }, {
    key: "rgba",
    get: function() {
      return L({}, this.rgb, {
        a: this.alpha
      });
    },
    set: function(r) {
      this.rgb = r;
    }
  }, {
    key: "hsl",
    get: function() {
      var r = e.hsvToHsl(this.$), o = r.h, a = r.s, i = r.l;
      return {
        h: oe(o),
        s: oe(a),
        l: oe(i)
      };
    },
    set: function(r) {
      this.hsv = L({}, e.hslToHsv(r), {
        a: r.a === void 0 ? 1 : r.a
      });
    }
  }, {
    key: "hsla",
    get: function() {
      return L({}, this.hsl, {
        a: this.alpha
      });
    },
    set: function(r) {
      this.hsl = r;
    }
  }, {
    key: "rgbString",
    get: function() {
      var r = this.rgb;
      return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    set: function(r) {
      var o, a, i, l, u = 1;
      if ((o = Ni.exec(r)) ? (a = N(o[1], 255), i = N(o[2], 255), l = N(o[3], 255)) : (o = Bi.exec(r)) && (a = N(o[1], 255), i = N(o[2], 255), l = N(o[3], 255), u = N(o[4], 1)), o)
        this.rgb = {
          r: a,
          g: i,
          b: l,
          a: u
        };
      else
        throw new Error("Invalid rgb string");
    }
  }, {
    key: "rgbaString",
    get: function() {
      var r = this.rgba;
      return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    set: function(r) {
      this.rgbString = r;
    }
  }, {
    key: "hexString",
    get: function() {
      var r = this.rgb;
      return "#" + J(r.r) + J(r.g) + J(r.b);
    },
    set: function(r) {
      var o, a, i, l, u = 255;
      if ((o = Gi.exec(r)) ? (a = B(o[1]) * 17, i = B(o[2]) * 17, l = B(o[3]) * 17) : (o = Vi.exec(r)) ? (a = B(o[1]) * 17, i = B(o[2]) * 17, l = B(o[3]) * 17, u = B(o[4]) * 17) : (o = Wi.exec(r)) ? (a = B(o[1]), i = B(o[2]), l = B(o[3])) : (o = Ui.exec(r)) && (a = B(o[1]), i = B(o[2]), l = B(o[3]), u = B(o[4])), o)
        this.rgb = {
          r: a,
          g: i,
          b: l,
          a: u / 255
        };
      else
        throw new Error("Invalid hex string");
    }
  }, {
    key: "hex8String",
    get: function() {
      var r = this.rgba;
      return "#" + J(r.r) + J(r.g) + J(r.b) + J(ce(r.a * 255));
    },
    set: function(r) {
      this.hexString = r;
    }
  }, {
    key: "hslString",
    get: function() {
      var r = this.hsl;
      return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
    },
    set: function(r) {
      var o, a, i, l, u = 1;
      if ((o = Li.exec(r)) ? (a = N(o[1], 360), i = N(o[2], 100), l = N(o[3], 100)) : (o = Fi.exec(r)) && (a = N(o[1], 360), i = N(o[2], 100), l = N(o[3], 100), u = N(o[4], 1)), o)
        this.hsl = {
          h: a,
          s: i,
          l,
          a: u
        };
      else
        throw new Error("Invalid hsl string");
    }
  }, {
    key: "hslaString",
    get: function() {
      var r = this.hsla;
      return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
    },
    set: function(r) {
      this.hslString = r;
    }
  }]), e;
}(), Xi = {
  sliderShape: "bar",
  sliderType: "value",
  minTemperature: 2200,
  maxTemperature: 11e3
};
function ft(e) {
  var n, t = e.width, r = e.sliderSize, o = e.borderWidth, a = e.handleRadius, i = e.padding, l = e.sliderShape, u = e.layoutDirection === "horizontal";
  return r = (n = r) != null ? n : i * 2 + a * 2, l === "circle" ? {
    handleStart: e.padding + e.handleRadius,
    handleRange: t - i * 2 - a * 2,
    width: t,
    height: t,
    cx: t / 2,
    cy: t / 2,
    radius: t / 2 - o / 2
  } : {
    handleStart: r / 2,
    handleRange: t - r,
    radius: r / 2,
    x: 0,
    y: 0,
    width: u ? r : t,
    height: u ? t : r
  };
}
function Zi(e, n) {
  var t = n.hsva, r = n.rgb;
  switch (e.sliderType) {
    case "red":
      return r.r / 2.55;
    case "green":
      return r.g / 2.55;
    case "blue":
      return r.b / 2.55;
    case "alpha":
      return t.a * 100;
    case "kelvin":
      var o = e.minTemperature, a = e.maxTemperature, i = a - o, l = (n.kelvin - o) / i * 100;
      return Math.max(0, Math.min(l, 100));
    case "hue":
      return t.h /= 3.6;
    case "saturation":
      return t.s;
    case "value":
    default:
      return t.v;
  }
}
function Yi(e, n, t) {
  var r = ft(e), o = r.handleRange, a = r.handleStart, i;
  e.layoutDirection === "horizontal" ? i = -1 * t + o + a : i = n - a, i = Math.max(Math.min(i, o), 0);
  var l = Math.round(100 / o * i);
  switch (e.sliderType) {
    case "kelvin":
      var u = e.minTemperature, c = e.maxTemperature, d = c - u;
      return u + d * (l / 100);
    case "alpha":
      return l / 100;
    case "hue":
      return l * 3.6;
    case "red":
    case "blue":
    case "green":
      return l * 2.55;
    default:
      return l;
  }
}
function Ki(e, n) {
  var t = ft(e), r = t.width, o = t.height, a = t.handleRange, i = t.handleStart, l = e.layoutDirection === "horizontal", u = Zi(e, n), c = l ? r / 2 : o / 2, d = i + u / 100 * a;
  return l && (d = -1 * d + a + i * 2), {
    x: l ? c : d,
    y: l ? d : c
  };
}
function Qi(e, n) {
  var t = n.hsv, r = n.rgb;
  switch (e.sliderType) {
    case "red":
      return [[0, "rgb(0," + r.g + "," + r.b + ")"], [100, "rgb(255," + r.g + "," + r.b + ")"]];
    case "green":
      return [[0, "rgb(" + r.r + ",0," + r.b + ")"], [100, "rgb(" + r.r + ",255," + r.b + ")"]];
    case "blue":
      return [[0, "rgb(" + r.r + "," + r.g + ",0)"], [100, "rgb(" + r.r + "," + r.g + ",255)"]];
    case "alpha":
      return [[0, "rgba(" + r.r + "," + r.g + "," + r.b + ",0)"], [100, "rgb(" + r.r + "," + r.g + "," + r.b + ")"]];
    case "kelvin":
      for (var o = [], a = e.minTemperature, i = e.maxTemperature, l = 8, u = i - a, c = a, d = 0; c < i; c += u / l, d += 1) {
        var s = ae.kelvinToRgb(c), f = s.r, p = s.g, g = s.b;
        o.push([100 / l * d, "rgb(" + f + "," + p + "," + g + ")"]);
      }
      return o;
    case "hue":
      return [[0, "#f00"], [16.666, "#ff0"], [33.333, "#0f0"], [50, "#0ff"], [66.666, "#00f"], [83.333, "#f0f"], [100, "#f00"]];
    case "saturation":
      var m = ae.hsvToHsl({
        h: t.h,
        s: 0,
        v: t.v
      }), _ = ae.hsvToHsl({
        h: t.h,
        s: 100,
        v: t.v
      });
      return [[0, "hsl(" + m.h + "," + m.s + "%," + m.l + "%)"], [100, "hsl(" + _.h + "," + _.s + "%," + _.l + "%)"]];
    case "value":
    default:
      var A = ae.hsvToHsl({
        h: t.h,
        s: t.s,
        v: 100
      });
      return [[0, "#000"], [100, "hsl(" + A.h + "," + A.s + "%," + A.l + "%)"]];
  }
}
var _n = Math.PI * 2, Ji = function(n, t) {
  return (n % t + t) % t;
}, Cn = function(n, t) {
  return Math.sqrt(n * n + t * t);
};
function wn(e) {
  return e.width / 2 - e.padding - e.handleRadius - e.borderWidth;
}
function el(e, n, t) {
  var r = $e(e), o = r.cx, a = r.cy, i = e.width / 2;
  return Cn(o - n, a - t) < i;
}
function $e(e) {
  var n = e.width / 2;
  return {
    width: e.width,
    radius: n - e.borderWidth,
    cx: n,
    cy: n
  };
}
function An(e, n, t) {
  var r = e.wheelAngle, o = e.wheelDirection;
  return t && o === "clockwise" ? n = r + n : o === "clockwise" ? n = 360 - r + n : t && o === "anticlockwise" ? n = r + 180 - n : o === "anticlockwise" && (n = r - n), Ji(n, 360);
}
function tl(e, n) {
  var t = n.hsv, r = $e(e), o = r.cx, a = r.cy, i = wn(e), l = (180 + An(e, t.h, !0)) * (_n / 360), u = t.s / 100 * i, c = e.wheelDirection === "clockwise" ? -1 : 1;
  return {
    x: o + u * Math.cos(l) * c,
    y: a + u * Math.sin(l) * c
  };
}
function Bt(e, n, t) {
  var r = $e(e), o = r.cx, a = r.cy, i = wn(e);
  n = o - n, t = a - t;
  var l = An(e, Math.atan2(-t, -n) * (360 / _n)), u = Math.min(Cn(n, t), i);
  return {
    h: Math.round(l),
    s: Math.round(100 / i * u)
  };
}
function pt(e) {
  var n = e.width, t = e.boxHeight, r = e.padding, o = e.handleRadius;
  return {
    width: n,
    height: t ?? n,
    radius: r + o
  };
}
function Lt(e, n, t) {
  var r = pt(e), o = r.width, a = r.height, i = r.radius, l = i, u = o - i * 2, c = a - i * 2, d = (n - l) / u * 100, s = (t - l) / c * 100;
  return {
    s: Math.max(0, Math.min(d, 100)),
    v: Math.max(0, Math.min(100 - s, 100))
  };
}
function nl(e, n) {
  var t = pt(e), r = t.width, o = t.height, a = t.radius, i = n.hsv, l = a, u = r - a * 2, c = o - a * 2;
  return {
    x: l + i.s / 100 * u,
    y: l + (c - i.v / 100 * c)
  };
}
function rl(e, n) {
  var t = n.hue;
  return [
    // saturation gradient
    [[0, "#fff"], [100, "hsl(" + t + ",100%,50%)"]],
    // lightness gradient
    [[0, "rgba(0,0,0,0)"], [100, "#000"]]
  ];
}
var We;
function ol(e) {
  We || (We = document.getElementsByTagName("base"));
  var n = window.navigator.userAgent, t = /^((?!chrome|android).)*safari/i.test(n), r = /iPhone|iPod|iPad/i.test(n), o = window.location;
  return (t || r) && We.length > 0 ? o.protocol + "//" + o.host + o.pathname + o.search + e : e;
}
function xn(e, n, t, r) {
  for (var o = 0; o < r.length; o++) {
    var a = r[o].x - n, i = r[o].y - t, l = Math.sqrt(a * a + i * i);
    if (l < e.handleRadius)
      return o;
  }
  return null;
}
function ht(e) {
  return {
    boxSizing: "border-box",
    border: e.borderWidth + "px solid " + e.borderColor
  };
}
function Ke(e, n, t) {
  return e + "-gradient(" + n + ", " + t.map(function(r) {
    var o = r[0], a = r[1];
    return a + " " + o + "%";
  }).join(",") + ")";
}
function H(e) {
  return typeof e == "string" ? e : e + "px";
}
var al = {
  width: 300,
  height: 300,
  color: "#fff",
  colors: [],
  padding: 6,
  layoutDirection: "vertical",
  borderColor: "#fff",
  borderWidth: 0,
  handleRadius: 8,
  activeHandleRadius: null,
  handleSvg: null,
  handleProps: {
    x: 0,
    y: 0
  },
  wheelLightness: !0,
  wheelAngle: 0,
  wheelDirection: "anticlockwise",
  sliderSize: null,
  sliderMargin: 12,
  boxHeight: null
}, Ft = [
  "mousemove",
  "touchmove",
  "mouseup",
  "touchend"
  /* TouchEnd */
], Me = /* @__PURE__ */ function(e) {
  function n(t) {
    e.call(this, t), this.uid = (Math.random() + 1).toString(36).substring(5);
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.render = function(r) {
    var o = this.handleEvent.bind(this), a = {
      onMouseDown: o,
      // https://github.com/jaames/iro.js/issues/126
      // https://github.com/preactjs/preact/issues/2113#issuecomment-553408767
      ontouchstart: o
    }, i = r.layoutDirection === "horizontal", l = r.margin === null ? r.sliderMargin : r.margin, u = {
      overflow: "visible",
      display: i ? "inline-block" : "block"
    };
    return r.index > 0 && (u[i ? "marginLeft" : "marginTop"] = l), C(Pe, null, r.children(this.uid, a, u));
  }, n.prototype.handleEvent = function(r) {
    var o = this, a = this.props.onInput, i = this.base.getBoundingClientRect();
    r.preventDefault();
    var l = r.touches ? r.changedTouches[0] : r, u = l.clientX - i.left, c = l.clientY - i.top;
    switch (r.type) {
      case "mousedown":
      case "touchstart":
        var d = a(
          u,
          c,
          0
          /* Start */
        );
        d !== !1 && Ft.forEach(function(s) {
          document.addEventListener(s, o, { passive: !1 });
        });
        break;
      case "mousemove":
      case "touchmove":
        a(
          u,
          c,
          1
          /* Move */
        );
        break;
      case "mouseup":
      case "touchend":
        a(
          u,
          c,
          2
          /* End */
        ), Ft.forEach(function(s) {
          document.removeEventListener(s, o, { passive: !1 });
        });
        break;
    }
  }, n;
}(ie);
function re(e) {
  var n = e.r, t = e.url, r = n, o = n;
  return C(
    "svg",
    { className: "IroHandle IroHandle--" + e.index + " " + (e.isActive ? "IroHandle--isActive" : ""), style: {
      "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0);",
      transform: "translate(" + H(e.x) + ", " + H(e.y) + ")",
      willChange: "transform",
      top: H(-n),
      left: H(-n),
      width: H(n * 2),
      height: H(n * 2),
      position: "absolute",
      overflow: "visible"
    } },
    t && C("use", Object.assign({ xlinkHref: ol(t) }, e.props)),
    !t && C("circle", { cx: r, cy: o, r: n, fill: "none", "stroke-width": 2, stroke: "#000" }),
    !t && C("circle", { cx: r, cy: o, r: n - 2, fill: e.fill, "stroke-width": 2, stroke: "#fff" })
  );
}
re.defaultProps = {
  fill: "none",
  x: 0,
  y: 0,
  r: 8,
  url: null,
  props: { x: 0, y: 0 }
};
function Oe(e) {
  var n = e.activeIndex, t = n !== void 0 && n < e.colors.length ? e.colors[n] : e.color, r = ft(e), o = r.width, a = r.height, i = r.radius, l = Ki(e, t), u = Qi(e, t);
  function c(d, s, f) {
    var p = Yi(e, d, s);
    e.parent.inputActive = !0, t[e.sliderType] = p, e.onInput(f, e.id);
  }
  return C(Me, Object.assign({}, e, { onInput: c }), function(d, s, f) {
    return C(
      "div",
      Object.assign({}, s, { className: "IroSlider", style: Object.assign(
        {},
        {
          position: "relative",
          width: H(o),
          height: H(a),
          borderRadius: H(i),
          // checkered bg to represent alpha
          background: "conic-gradient(#ccc 25%, #fff 0 50%, #ccc 0 75%, #fff 0)",
          backgroundSize: "8px 8px"
        },
        f
      ) }),
      C("div", { className: "IroSliderGradient", style: Object.assign(
        {},
        {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: H(i),
          background: Ke("linear", e.layoutDirection === "horizontal" ? "to top" : "to right", u)
        },
        ht(e)
      ) }),
      C(re, { isActive: !0, index: t.index, r: e.handleRadius, url: e.handleSvg, props: e.handleProps, x: l.x, y: l.y })
    );
  });
}
Oe.defaultProps = Object.assign({}, Xi);
function il(e) {
  var n = pt(e), t = n.width, r = n.height, o = n.radius, a = e.colors, i = e.parent, l = e.activeIndex, u = l !== void 0 && l < e.colors.length ? e.colors[l] : e.color, c = rl(e, u), d = a.map(function(f) {
    return nl(e, f);
  });
  function s(f, p, g) {
    if (g === 0) {
      var m = xn(e, f, p, d);
      m !== null ? i.setActiveColor(m) : (i.inputActive = !0, u.hsv = Lt(e, f, p), e.onInput(g, e.id));
    } else
      g === 1 && (i.inputActive = !0, u.hsv = Lt(e, f, p));
    e.onInput(g, e.id);
  }
  return C(Me, Object.assign({}, e, { onInput: s }), function(f, p, g) {
    return C(
      "div",
      Object.assign({}, p, { className: "IroBox", style: Object.assign(
        {},
        {
          width: H(t),
          height: H(r),
          position: "relative"
        },
        g
      ) }),
      C("div", { className: "IroBox", style: Object.assign(
        {},
        {
          width: "100%",
          height: "100%",
          borderRadius: H(o)
        },
        ht(e),
        { background: Ke("linear", "to bottom", c[1]) + "," + Ke("linear", "to right", c[0]) }
      ) }),
      a.filter(function(m) {
        return m !== u;
      }).map(function(m) {
        return C(re, { isActive: !1, index: m.index, fill: m.hslString, r: e.handleRadius, url: e.handleSvg, props: e.handleProps, x: d[m.index].x, y: d[m.index].y });
      }),
      C(re, { isActive: !0, index: u.index, fill: u.hslString, r: e.activeHandleRadius || e.handleRadius, url: e.handleSvg, props: e.handleProps, x: d[u.index].x, y: d[u.index].y })
    );
  });
}
var ll = "conic-gradient(red, yellow, lime, aqua, blue, magenta, red)", sl = "conic-gradient(red, magenta, blue, aqua, lime, yellow, red)";
function kn(e) {
  var n = $e(e), t = n.width, r = e.colors;
  e.borderWidth;
  var o = e.parent, a = e.color, i = a.hsv, l = r.map(function(d) {
    return tl(e, d);
  }), u = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    boxSizing: "border-box"
  };
  function c(d, s, f) {
    if (f === 0) {
      if (!el(e, d, s))
        return !1;
      var p = xn(e, d, s, l);
      p !== null ? o.setActiveColor(p) : (o.inputActive = !0, a.hsv = Bt(e, d, s), e.onInput(f, e.id));
    } else
      f === 1 && (o.inputActive = !0, a.hsv = Bt(e, d, s));
    e.onInput(f, e.id);
  }
  return C(Me, Object.assign({}, e, { onInput: c }), function(d, s, f) {
    return C(
      "div",
      Object.assign({}, s, { className: "IroWheel", style: Object.assign(
        {},
        {
          width: H(t),
          height: H(t),
          position: "relative"
        },
        f
      ) }),
      C("div", { className: "IroWheelHue", style: Object.assign(
        {},
        u,
        {
          transform: "rotateZ(" + (e.wheelAngle + 90) + "deg)",
          background: e.wheelDirection === "clockwise" ? ll : sl
        }
      ) }),
      C("div", { className: "IroWheelSaturation", style: Object.assign(
        {},
        u,
        { background: "radial-gradient(circle closest-side, #fff, transparent)" }
      ) }),
      e.wheelLightness && C("div", { className: "IroWheelLightness", style: Object.assign(
        {},
        u,
        {
          background: "#000",
          opacity: 1 - i.v / 100
        }
      ) }),
      C("div", { className: "IroWheelBorder", style: Object.assign(
        {},
        u,
        ht(e)
      ) }),
      r.filter(function(p) {
        return p !== a;
      }).map(function(p) {
        return C(re, { isActive: !1, index: p.index, fill: p.hslString, r: e.handleRadius, url: e.handleSvg, props: e.handleProps, x: l[p.index].x, y: l[p.index].y });
      }),
      C(re, { isActive: !0, index: a.index, fill: a.hslString, r: e.activeHandleRadius || e.handleRadius, url: e.handleSvg, props: e.handleProps, x: l[a.index].x, y: l[a.index].y })
    );
  });
}
function ul(e) {
  var n = function(t, r) {
    var o, a = document.createElement("div");
    Mi(C(e, Object.assign(
      {},
      { ref: function(l) {
        return o = l;
      } },
      r
    )), a);
    function i() {
      var l = t instanceof Element ? t : document.querySelector(t);
      l.appendChild(o.base), o.onMount(l);
    }
    return document.readyState !== "loading" ? i() : document.addEventListener("DOMContentLoaded", i), o;
  };
  return n.prototype = e.prototype, Object.assign(n, e), n.__component = e, n;
}
var Sn = /* @__PURE__ */ function(e) {
  function n(t) {
    var r = this;
    e.call(this, t), this.colors = [], this.inputActive = !1, this.events = {}, this.activeEvents = {}, this.deferredEvents = {}, this.id = t.id;
    var o = t.colors.length > 0 ? t.colors : [t.color];
    o.forEach(function(a) {
      return r.addColor(a);
    }), this.setActiveColor(0), this.state = Object.assign(
      {},
      t,
      {
        color: this.color,
        colors: this.colors,
        layout: t.layout
      }
    );
  }
  return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.addColor = function(r, o) {
    o === void 0 && (o = this.colors.length);
    var a = new ae(r, this.onColorChange.bind(this));
    this.colors.splice(o, 0, a), this.colors.forEach(function(i, l) {
      return i.index = l;
    }), this.state && this.setState({ colors: this.colors }), this.deferredEmit("color:init", a);
  }, n.prototype.removeColor = function(r) {
    var o = this.colors.splice(r, 1)[0];
    o.unbind(), this.colors.forEach(function(a, i) {
      return a.index = i;
    }), this.state && this.setState({ colors: this.colors }), o.index === this.color.index && this.setActiveColor(0), this.emit("color:remove", o);
  }, n.prototype.setActiveColor = function(r) {
    this.color = this.colors[r], this.state && this.setState({ color: this.color }), this.emit("color:setActive", this.color);
  }, n.prototype.setColors = function(r, o) {
    var a = this;
    o === void 0 && (o = 0), this.colors.forEach(function(i) {
      return i.unbind();
    }), this.colors = [], r.forEach(function(i) {
      return a.addColor(i);
    }), this.setActiveColor(o), this.emit("color:setAll", this.colors);
  }, n.prototype.on = function(r, o) {
    var a = this, i = this.events;
    (Array.isArray(r) ? r : [r]).forEach(function(l) {
      (i[l] || (i[l] = [])).push(o), a.deferredEvents[l] && (a.deferredEvents[l].forEach(function(u) {
        o.apply(null, u);
      }), a.deferredEvents[l] = []);
    });
  }, n.prototype.off = function(r, o) {
    var a = this;
    (Array.isArray(r) ? r : [r]).forEach(function(i) {
      var l = a.events[i];
      l && l.splice(l.indexOf(o), 1);
    });
  }, n.prototype.emit = function(r) {
    for (var o = this, a = [], i = arguments.length - 1; i-- > 0; )
      a[i] = arguments[i + 1];
    var l = this.activeEvents, u = l.hasOwnProperty(r) ? l[r] : !1;
    if (!u) {
      l[r] = !0;
      var c = this.events[r] || [];
      c.forEach(function(d) {
        return d.apply(o, a);
      }), l[r] = !1;
    }
  }, n.prototype.deferredEmit = function(r) {
    for (var o, a = [], i = arguments.length - 1; i-- > 0; )
      a[i] = arguments[i + 1];
    var l = this.deferredEvents;
    (o = this).emit.apply(o, [r].concat(a)), (l[r] || (l[r] = [])).push(a);
  }, n.prototype.setOptions = function(r) {
    this.setState(r);
  }, n.prototype.resize = function(r) {
    this.setOptions({ width: r });
  }, n.prototype.reset = function() {
    this.colors.forEach(function(r) {
      return r.reset();
    }), this.setState({ colors: this.colors });
  }, n.prototype.onMount = function(r) {
    this.el = r, this.deferredEmit("mount", this);
  }, n.prototype.onColorChange = function(r, o) {
    this.setState({ color: this.color }), this.inputActive && (this.inputActive = !1, this.emit("input:change", r, o)), this.emit("color:change", r, o);
  }, n.prototype.emitInputEvent = function(r, o) {
    r === 0 ? this.emit("input:start", this.color, o) : r === 1 ? this.emit("input:move", this.color, o) : r === 2 && this.emit("input:end", this.color, o);
  }, n.prototype.render = function(r, o) {
    var a = this, i = o.layout;
    if (!Array.isArray(i)) {
      switch (i) {
        default:
          i = [
            { component: kn },
            { component: Oe }
          ];
      }
      o.transparency && i.push({
        component: Oe,
        options: {
          sliderType: "alpha"
        }
      });
    }
    return C("div", { class: "IroColorPicker", id: o.id, style: {
      display: o.display
    } }, i.map(function(l, u) {
      var c = l.component, d = l.options;
      return C(c, Object.assign({}, o, d, { ref: void 0, onInput: a.emitInputEvent.bind(a), parent: a, index: u }));
    }));
  }, n;
}(ie);
Sn.defaultProps = Object.assign(
  {},
  al,
  {
    colors: [],
    display: "block",
    id: null,
    layout: "default",
    margin: null
  }
);
var cl = ul(Sn), Qe;
(function(e) {
  e.version = "5.5.2", e.Color = ae, e.ColorPicker = cl, function(n) {
    n.h = C, n.ComponentBase = Me, n.Handle = re, n.Slider = Oe, n.Wheel = kn, n.Box = il;
  }(e.ui || (e.ui = {}));
})(Qe || (Qe = {}));
var Ue = Qe;
const Je = /* @__PURE__ */ Object.assign({ inheritAttrs: !0 }, {
  __name: "ColorPickerPreview",
  props: {
    background: {
      type: String,
      default: "#ffffff"
    },
    active: {
      type: Boolean,
      default: !1
    },
    tooltipText: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e) {
    return (n, t) => {
      const r = M("ap-tooltip");
      return v(), P(r, { title: e.tooltipText }, {
        default: I(() => [
          y("div", {
            style: Mn({ background: e.background }),
            class: X([
              "h-8 w-8 rounded border-solid border-[3px] cursor-pointer bg-origin-border",
              { "!border-[#615df4]": e.active, "border-[#12121229]": !e.active, [n.$attrs.class]: !0 }
            ]),
            onClick: t[0] || (t[0] = (o) => n.$emit("click"))
          }, null, 6)
        ]),
        _: 1
      }, 8, ["title"]);
    };
  }
}), we = /* @__PURE__ */ Object.assign({ inheritAttrs: !0 }, {
  __name: "ColorPickerInput",
  props: /* @__PURE__ */ gt({
    showColorPreview: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    previewColor: { type: String, default: null },
    previewInput: { type: Boolean, default: !1 },
    focusInput: { type: Boolean, default: !1 }
  }, {
    color: { default: "#ffffff" },
    colorModifiers: {}
  }),
  emits: /* @__PURE__ */ gt(["blur", "keyup.enter", "click.preview", "preview"], ["update:color"]),
  setup(e, { emit: n }) {
    const t = e, r = R(null), o = n, a = Dn(e, "color");
    function i() {
      r.value && t.focusInput && r.value.focus(), o("preview");
    }
    return (l, u) => (v(), E("div", {
      class: X([
        "grid gap-4 grid-cols-[2rem_auto] w-full",
        { [l.$attrs.class]: !0 }
      ])
    }, [
      e.showColorPreview ? (v(), P(Je, {
        key: 0,
        background: e.previewColor ?? a.value,
        active: e.active,
        onClick: i
      }, null, 8, ["background", "active"])) : $("", !0),
      O(h(Kt), {
        ref_key: "inputElement",
        ref: r,
        class: "border-solid rounded border border-[#12121229] focus:border-primary text-b[#121212DB] text-sm uppercase p-3 h-8 bg-[#FAFAFA]",
        value: a.value,
        "onUpdate:value": u[0] || (u[0] = (c) => a.value = c),
        readonly: e.readonly,
        onClick: u[1] || (u[1] = (c) => e.previewInput && i())
      }, null, 8, ["value", "readonly"])
    ], 2));
  }
}), he = "#DE3857", dl = "#F8D3DA", S = {
  COLOR: "color",
  GRADIENT: "gradient"
}, z = {
  FIRST: "first",
  SECOND: "second"
};
function fl(e) {
  var n = /#[0-9a-fA-F]{6}/g, t = e.match(n);
  return t && t.length >= 2 ? [t[0], t[t.length - 1]] : null;
}
function pl(e) {
  try {
    if (!e || typeof e != "string")
      return he;
    if (e.includes("#"))
      return e.length === 4 ? `#${e[1]}${e[1]}${e[2]}${e[2]}${e[3]}${e[3]}` : e.length === 7 ? e : he;
    const n = e.split("(")[1].split(")")[0].split(", "), t = parseInt(n[0]), r = parseInt(n[1]), o = parseInt(n[2]);
    return ((i, l, u) => "#" + [i, l, u].map((c) => {
      const d = c.toString(16);
      return d.length === 1 ? "0" + d : d;
    }).join(""))(t, r, o);
  } catch {
    return he;
  }
}
const hl = { class: "flex w-full mt-2" }, vl = { class: "flex flex-col gap-3" }, gl = { class: "flex justify-between w-full" }, ml = {
  key: 0,
  class: "flex flex-row gap-2"
}, bl = { class: "flex flex-col gap-3" }, yl = { class: "relative nw-fit max-w-fit" }, _l = /* @__PURE__ */ y("svg", null, [
  /* @__PURE__ */ y("defs", null, [
    /* @__PURE__ */ y("g", { id: "handle" }, [
      /* @__PURE__ */ y("rect", {
        x: "1.23877",
        y: "0",
        width: "20.2773",
        height: "30",
        rx: "10.6387",
        fill: "none",
        stroke: "white"
      })
    ])
  ])
], -1), Cl = [
  _l
], wl = {
  key: 1,
  class: "flex flex-col gap-3"
}, Al = {
  __name: "ColorPicker",
  props: {
    label: {
      type: String,
      default: "Label"
    },
    color: {
      type: String,
      default: "#ffffff"
    },
    isGradient: {
      type: Boolean,
      default: !1
    },
    linearTooltipText: {
      type: String,
      default: "Color"
    },
    gradientTooltipText: {
      type: String,
      default: "Gradient"
    },
    labelClass: {
      type: String,
      default: ""
    },
    selectionColor: {
      type: String,
      default: "#615df4"
    },
    autoAdjustOverflow: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    previewInput: {
      type: Boolean,
      default: !1
    },
    focusInput: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["change"],
  setup(e, { emit: n }) {
    const t = e, r = n, o = R(!1), a = R(null), i = R(!1), l = R(S.COLOR), u = R(z.FIRST), c = R(null), d = R("#FFFFFF"), s = R(he), f = R({
      firstColor: he,
      secondColor: dl
    });
    mt(() => l.value === S.COLOR ? s.value : "Linear");
    const p = mt(
      () => `linear-gradient(180deg, ${f.value.firstColor} 20%, ${f.value.secondColor} 100%)`
    );
    function g(k) {
      k ? i.value = o.value : (i.value = !1, o.value = !1);
    }
    function m(k, b, x = null) {
      const De = k.target.value;
      b === S.COLOR ? s.value = De : x === z.FIRST ? f.value.firstColor = De : f.value.secondColor = De, _();
    }
    function _() {
      return {
        [S.GRADIENT]: () => r("change", p.value),
        [S.COLOR]: () => r("change", s.value)
      }[l.value]();
    }
    function A() {
      c.value = new Ue.ColorPicker(a.value, {
        width: 224,
        color: d.value,
        borderWidth: 1,
        handleSvg: "#handle",
        layout: [
          {
            component: Ue.ui.Box
          },
          {
            component: Ue.ui.Slider,
            options: {
              id: "hue-slider",
              sliderType: "hue"
            }
          }
        ]
      }), c.value.on("color:change", function({ hexString: k }) {
        l.value === S.COLOR && (s.value = k), l.value === S.GRADIENT && u.value === z.FIRST && (f.value.firstColor = k), l.value === S.GRADIENT && u.value === z.SECOND && (f.value.secondColor = k), _();
      });
    }
    function w(k) {
      l.value = k, u.value = z.FIRST, _();
    }
    function F(k, b) {
      u.value = k, d.value = b;
    }
    function D() {
      o.value = !o.value, c.value ? c.value.color.hexString = t.color.includes("gradient") ? f.value.firstColor : s.value : setTimeout(() => {
        A();
      }, 100), i.value = !i.value;
    }
    return Ut(
      () => t.color,
      (k) => {
        k.includes("gradient") ? ([f.value.firstColor, f.value.secondColor] = fl(k), l.value = S.GRADIENT) : (l.value = S.COLOR, s.value = pl(k), d.value = s.value);
      },
      { immediate: !0 }
    ), (k, b) => (v(), P(h(Zt), { layout: "vertical" }, {
      default: I(() => [
        O(h(Yt), null, {
          default: I(() => [
            y("div", {
              class: X([, { [t.labelClass]: !0 }])
            }, V(t.label), 3),
            y("div", hl, [
              k.$slots.handler ? (v(), E("div", {
                key: 0,
                onClick: D,
                class: "cursor-pointer"
              }, [
                j(k.$slots, "handler")
              ])) : $("", !0),
              O(h(Qt), {
                open: i.value,
                "onUpdate:open": b[13] || (b[13] = (x) => i.value = x),
                trigger: "click",
                onOpenChange: g,
                "auto-adjust-overflow": e.autoAdjustOverflow,
                overlayClassName: "color-picker-popover",
                align: {
                  overflow: {
                    adjustX: !0,
                    adjustY: !0,
                    alwaysByViewport: !0
                  }
                }
              }, {
                content: I(() => [
                  y("div", vl, [
                    y("div", gl, [
                      e.isGradient ? (v(), E("div", ml, [
                        O(Je, {
                          class: "w-6 h-6",
                          tooltipText: e.linearTooltipText,
                          background: s.value,
                          active: l.value === h(S).COLOR,
                          onClick: b[0] || (b[0] = (x) => w(h(S).COLOR))
                        }, null, 8, ["tooltipText", "background", "active"]),
                        O(Je, {
                          class: "w-6 h-6",
                          tooltipText: e.gradientTooltipText,
                          background: p.value,
                          active: l.value === h(S).GRADIENT,
                          onClick: b[1] || (b[1] = (x) => w(h(S).GRADIENT))
                        }, null, 8, ["tooltipText", "background", "active"])
                      ])) : $("", !0),
                      O(h(vi), {
                        class: "text-[#12121299] cursor-pointer ml-auto",
                        onClick: b[2] || (b[2] = (x) => i.value = !1)
                      })
                    ]),
                    y("div", bl, [
                      y("div", yl, [
                        y("div", {
                          class: "iron-color-picker-wrapper",
                          ref_key: "picker",
                          ref: a
                        }, Cl, 512)
                      ]),
                      l.value === h(S).COLOR ? (v(), P(we, {
                        key: 0,
                        color: s.value,
                        "onUpdate:color": b[3] || (b[3] = (x) => s.value = x),
                        onChange: b[4] || (b[4] = (x) => m(x, h(S).COLOR)),
                        onKeyup: je(_, ["enter"]),
                        onBlur: _
                      }, null, 8, ["color"])) : $("", !0),
                      l.value === h(S).GRADIENT ? (v(), E("div", wl, [
                        O(we, {
                          color: f.value.firstColor,
                          "onUpdate:color": b[5] || (b[5] = (x) => f.value.firstColor = x),
                          onKeyup: je(_, ["enter"]),
                          onBlur: _,
                          onChange: b[6] || (b[6] = (x) => m(x, h(S).GRADIENT, h(z).FIRST)),
                          active: u.value == h(z).FIRST && l.value === h(S).GRADIENT,
                          onClick: b[7] || (b[7] = (x) => F(
                            h(z).FIRST,
                            f.value.firstColor
                          ))
                        }, null, 8, ["color", "active"]),
                        O(we, {
                          color: f.value.secondColor,
                          "onUpdate:color": b[8] || (b[8] = (x) => f.value.secondColor = x),
                          onChange: b[9] || (b[9] = (x) => m(x, h(S).GRADIENT, h(z).SECOND)),
                          onKeyup: je(_, ["enter"]),
                          active: u.value == h(z).SECOND && l.value === h(S).GRADIENT,
                          onClick: b[10] || (b[10] = (x) => F(
                            h(z).SECOND,
                            f.value.secondColor
                          )),
                          onBlur: _
                        }, null, 8, ["color", "active"])
                      ])) : $("", !0)
                    ])
                  ])
                ]),
                default: I(() => [
                  k.$slots.handler ? $("", !0) : (v(), P(we, {
                    key: 0,
                    onPreview: D,
                    onChange: b[11] || (b[11] = (x) => m(x, h(S).COLOR)),
                    color: s.value,
                    "onUpdate:color": b[12] || (b[12] = (x) => s.value = x),
                    active: i.value,
                    readonly: e.readonly,
                    previewInput: e.previewInput,
                    focusInput: e.focusInput,
                    class: "w-[10rem] cursor-pointer",
                    "preview-color": l.value === h(S).COLOR ? s.value : p.value
                  }, null, 8, ["color", "active", "readonly", "previewInput", "focusInput", "preview-color"]))
                ]),
                _: 1
              }, 8, ["open", "auto-adjust-overflow"])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}, xl = ["onClick"], kl = {
  __name: "ChipTabs",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ""
    }
  },
  emits: ["change", "update:activeKey"],
  setup(e, { emit: n }) {
    function t(o) {
      r("update:activeKey", o.key), r("change", o.key);
    }
    const r = n;
    return (o, a) => (v(!0), E(et, null, zt(e.tabs, (i) => (v(), E("button", me(o.$attrs, {
      key: i.key,
      role: "tab",
      tabindex: "0",
      class: ["inline-flex h-8 gap-1 p-2 transition-colors duration-200 ease-in-out rounded-lg cursor-pointer min-w-16 focus:bg-primary focus:bg-opacity-15 focus:outline-none hover:bg-primary hover:bg-opacity-15", {
        "bg-primary bg-opacity-15": e.activeKey === i.key,
        "bg-transparent": e.activeKey !== i.key
      }],
      onClick: (l) => t(i)
    }), [
      y("a", {
        class: X(["w-full overflow-hidden text-xs font-medium text-center no-underline bg-none", {
          "text-primary": e.activeKey === i.key,
          "text-secondary": e.activeKey !== i.key
        }])
      }, V(i.tab), 3)
    ], 16, xl))), 128));
  }
}, Sl = { class: "flex flex-col w-full cursor-pointer h-avatar-container p-4" }, Tl = { class: "grid items-center gap-2 w-full h-full text-black font-medium text-sm grid-cols-[32px_1fr] max-w-full" }, Ol = { class: "max-w-full text-ellipsis whitespace-nowrap overflow-hidden" }, Il = { class: "text-xs font-bold text-black dark:text-black max-w-full text-ellipsis whitespace-nowrap overflow-hidden" }, El = { class: "font-semibold text-black text-opacity-65 max-w-full text-ellipsis whitespace-nowrap overflow-hidden" }, Pl = {
  __name: "AvatarItem",
  props: {
    name: {
      type: String,
      required: !0
    },
    email: {
      type: String,
      required: !0
    },
    avatar: {
      type: String,
      required: !0
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const n = e;
    return (t, r) => {
      const o = M("ap-avatar"), a = M("ap-dropdown-item"), i = M("ap-dropdown-menu");
      return v(), P(i, me({ trigger: ["click"] }, t.$attrs), {
        head: I(() => [
          y("div", null, [
            y("div", Il, V(n.name), 1),
            y("div", El, V(n.email), 1)
          ])
        ]),
        items: I(() => [
          j(t.$slots, "items", {}, () => [
            (v(!0), E(et, null, zt(n.items, (l) => (v(), P(a, {
              key: l.text,
              text: l.text,
              icon: l.icon,
              selected: l.selected,
              onClick: l.onClick
            }, null, 8, ["text", "icon", "selected", "onClick"]))), 128))
          ])
        ]),
        default: I(() => [
          y("div", Sl, [
            y("div", Tl, [
              O(o, {
                src: n.avatar
              }, {
                default: I(() => [
                  Ie(V(n.avatar), 1)
                ]),
                _: 1
              }, 8, ["src"]),
              y("span", Ol, V(n.name), 1)
            ])
          ])
        ]),
        _: 3
      }, 16);
    };
  }
}, Rl = {
  key: 0,
  class: "text-sm font-semibold text-base text-opacity-65 mb-1 uppercase"
}, $l = { key: 0 }, Ml = {
  key: 1,
  class: "p-4"
}, Dl = {
  key: 3,
  class: "p-2"
}, jl = {
  __name: "DropdownMenu",
  props: {
    title: {
      type: String
    }
  },
  setup(e) {
    const n = qt(), t = e;
    return (r, o) => {
      const a = M("ap-divider"), i = M("ap-menu"), l = M("ap-dropdown");
      return v(), P(l, jn(Hn(r.$attrs)), {
        overlay: I(() => [
          j(r.$slots, "overlay", {}, () => [
            O(i, { class: "rounded-xl border border-gray-200 shadow" }, {
              default: I(() => [
                h(n).title || t.title ? (v(), E("div", Rl, [
                  t.title && !h(n).title ? (v(), E("div", $l, V(t.title), 1)) : $("", !0),
                  j(r.$slots, "title")
                ])) : $("", !0),
                h(n).head ? (v(), E("div", Ml, [
                  j(r.$slots, "head")
                ])) : $("", !0),
                h(n).head ? (v(), P(a, {
                  key: 2,
                  style: { margin: "0 0 8px 0" }
                })) : $("", !0),
                h(n).items ? (v(), E("div", Dl, [
                  j(r.$slots, "items")
                ])) : $("", !0)
              ]),
              _: 3
            })
          ])
        ]),
        default: I(() => [
          j(r.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
};
function Hl(e) {
  return Nn() ? (Bn(e), !0) : !1;
}
function Tn(e) {
  return typeof e == "function" ? e() : h(e);
}
const On = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Nl = Object.prototype.toString, Bl = (e) => Nl.call(e) === "[object Object]", ke = () => {
}, Ll = /* @__PURE__ */ Fl();
function Fl() {
  var e, n;
  return On && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function fe(e) {
  var n;
  const t = Tn(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const vt = On ? window : void 0;
function ve(...e) {
  let n, t, r, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, r, o] = e, n = vt) : [n, t, r, o] = e, !n)
    return ke;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const a = [], i = () => {
    a.forEach((d) => d()), a.length = 0;
  }, l = (d, s, f, p) => (d.addEventListener(s, f, p), () => d.removeEventListener(s, f, p)), u = Ut(
    () => [fe(n), Tn(o)],
    ([d, s]) => {
      if (i(), !d)
        return;
      const f = Bl(s) ? { ...s } : s;
      a.push(
        ...t.flatMap((p) => r.map((g) => l(d, p, g, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    u(), i();
  };
  return Hl(c), c;
}
let Gt = !1;
function Gl(e, n, t = {}) {
  const { window: r = vt, ignore: o = [], capture: a = !0, detectIframe: i = !1 } = t;
  if (!r)
    return ke;
  Ll && !Gt && (Gt = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", ke)), r.document.documentElement.addEventListener("click", ke));
  let l = !0;
  const u = (f) => o.some((p) => {
    if (typeof p == "string")
      return Array.from(r.document.querySelectorAll(p)).some((g) => g === f.target || f.composedPath().includes(g));
    {
      const g = fe(p);
      return g && (f.target === g || f.composedPath().includes(g));
    }
  }), d = [
    ve(r, "click", (f) => {
      const p = fe(e);
      if (!(!p || p === f.target || f.composedPath().includes(p))) {
        if (f.detail === 0 && (l = !u(f)), !l) {
          l = !0;
          return;
        }
        n(f);
      }
    }, { passive: !0, capture: a }),
    ve(r, "pointerdown", (f) => {
      const p = fe(e);
      l = !u(f) && !!(p && !f.composedPath().includes(p));
    }, { passive: !0 }),
    i && ve(r, "blur", (f) => {
      setTimeout(() => {
        var p;
        const g = fe(e);
        ((p = r.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(g != null && g.contains(r.document.activeElement)) && n(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((f) => f());
}
function Vl(e, n = {}) {
  const {
    delayEnter: t = 0,
    delayLeave: r = 0,
    window: o = vt
  } = n, a = R(!1);
  let i;
  const l = (u) => {
    const c = u ? t : r;
    i && (clearTimeout(i), i = void 0), c ? i = setTimeout(() => a.value = u, c) : a.value = u;
  };
  return o && (ve(e, "mouseenter", () => l(!0), { passive: !0 }), ve(e, "mouseleave", () => l(!1), { passive: !0 })), a;
}
const Wl = ["disabled"], Ul = { class: "ap-menu-item__text" }, zl = {
  __name: "DropdownItem",
  props: {
    text: {
      type: String
    },
    icon: {
      type: [Object, Function]
    },
    selected: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const n = R(null), t = Vl(n);
    return (r, o) => {
      const a = M("ap-menu-item");
      return v(), P(a, me(r.$attrs, { style: { all: "unset" } }), {
        default: I(() => [
          y("div", {
            disabled: e.disabled,
            ref_key: "item",
            ref: n,
            type: "text",
            class: X(["ap-menu-item flex items-center gap-2 p-2 rounded cursor-pointer font-normal text-xs", {
              "bg-primary bg-opacity-10 text-primary font-semibold": h(t),
              "bg-primary text-white": e.selected,
              "text-base opacity-86": !h(t) && !e.selected,
              "pointer-events-none bg-base bg-opacity-65": e.disabled
            }]),
            block: ""
          }, [
            j(r.$slots, "default", {}, () => [
              (v(), P(Xt(e.icon), { class: "ap-menu-item__icon" })),
              y("div", Ul, V(e.text), 1)
            ])
          ], 10, Wl)
        ]),
        _: 3
      }, 16);
    };
  }
}, Vt = {
  AVATAR: "avatar",
  IMAGE: "image"
}, ql = { class: "relative" }, Xl = { key: 0 }, Zl = ["src"], Yl = {
  key: 1,
  class: "w-full"
}, Kl = /* @__PURE__ */ y("svg", {
  width: "63",
  height: "63",
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ y("rect", {
    width: "63",
    height: "63",
    rx: "10",
    fill: "#121212",
    "fill-opacity": "0.1"
  }),
  /* @__PURE__ */ y("rect", {
    x: "15",
    y: "32.4263",
    width: "14.5746",
    height: "14.5735",
    rx: "3.92684",
    fill: "#121212",
    "fill-opacity": "0.3"
  }),
  /* @__PURE__ */ y("rect", {
    x: "32.4255",
    y: "15",
    width: "14.5746",
    height: "14.5735",
    rx: "3.92684",
    fill: "#121212",
    "fill-opacity": "0.3"
  }),
  /* @__PURE__ */ y("rect", {
    x: "15",
    y: "15",
    width: "14.5746",
    height: "14.5735",
    rx: "7.28676",
    fill: "#121212",
    "fill-opacity": "0.3"
  }),
  /* @__PURE__ */ y("rect", {
    x: "34.9402",
    y: "34.9419",
    width: "9.5482",
    height: "9.54748",
    rx: "4.77374",
    fill: "#121212",
    "fill-opacity": "0.3"
  })
], -1), Ql = [
  Kl
], Jl = { class: "text-white absolute w-full h-full z-10" }, es = { key: 0 }, ts = { key: 1 }, ns = {
  __name: "ImagePicker",
  props: {
    image: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: Vt.IMAGE
    },
    accept: {
      type: String,
      default: ".png, .jpg, .svg"
    }
  },
  emits: ["change"],
  setup(e, { emit: n }) {
    const t = e, r = n;
    function o(l) {
      const u = new FileReader();
      u.readAsDataURL(l.file), u.onload = () => {
        r("change", l);
      };
    }
    function a(l) {
      l.stopPropagation(), r("change", { file: null });
    }
    function i(l) {
      const u = l.type === "image/jpeg" || l.type === "image/png";
      u || message.error("You can only upload JPG/PNG file!");
      const c = l.size / 1024 / 1024 < 2;
      return c || message.error("Image must smaller than 2MB!"), u && c;
    }
    return (l, u) => {
      const c = M("ap-button"), d = M("ap-upload");
      return v(), P(d, {
        name: "avatar",
        class: X({
          "rounded-full": t.type === h(Vt).AVATAR
        }),
        customRequest: o,
        multiple: !1,
        "show-upload-list": !1,
        accept: t.accept,
        "before-upload": i
      }, {
        default: I(() => [
          y("div", ql, [
            t.image ? (v(), E("div", Xl, [
              y("img", {
                src: t.image,
                alt: "image"
              }, null, 8, Zl),
              O(c, {
                onClick: a,
                class: "text-secondary",
                type: "link",
                icon: ge(h(yi))
              }, null, 8, ["icon"])
            ])) : (v(), E("div", Yl, Ql)),
            y("div", Jl, [
              t.image ? (v(), E("div", es, "Edit")) : (v(), E("div", ts, "Upload Image"))
            ])
          ])
        ]),
        _: 1
      }, 8, ["class", "accept"]);
    };
  }
}, rs = {
  __name: "SiderItem",
  props: {
    text: {
      required: !0,
      type: String
    },
    icon: {
      type: [Object, Function]
    },
    selected: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  setup(e) {
    const n = e, t = R(null);
    return (r, o) => {
      const a = M("ap-button");
      return v(), P(a, {
        disabled: e.disabled,
        ref_key: "btn",
        ref: t,
        type: "text",
        class: X(["flex justify-start items-center px-4 py-2 rounded-lg gap-1 cursor-pointer w-full h-8 md:h-6 hocus:bg-primary hocus:bg-opacity-10 outline-none", {
          " dark:text-white text-secondary dark:text-opacity-65": !e.selected,
          "bg-primary bg-opacity-10 text-primary": e.selected,
          "pointer-events-none bg-secondary": e.disabled
        }])
      }, {
        icon: I(() => [
          j(r.$slots, "icon", {}, () => [
            (v(), P(Xt(e.icon), { class: "text-16" }))
          ])
        ]),
        default: I(() => [
          j(r.$slots, "default", {}, () => [
            Ie(V(n.text), 1)
          ])
        ]),
        _: 3
      }, 8, ["disabled", "class"]);
    };
  }
}, os = { class: "text-xs font-bold text-secondary dark:text-white" }, as = {
  __name: "SiderTitle",
  props: {
    title: {
      required: !0,
      type: String
    },
    button: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: [Object, Function]
    }
  },
  emits: ["action"],
  setup(e, { emit: n }) {
    const t = e, r = n, o = R(null), a = () => {
      r("action");
    };
    return (i, l) => {
      const u = M("ap-button");
      return v(), E("div", {
        class: X(["flex justify-between items-center px-4 py-1", { "cursor-pointer": t.button }])
      }, [
        y("div", os, [
          j(i.$slots, "default", {}, () => [
            Ie(V(t.title), 1)
          ])
        ]),
        j(i.$slots, "button", {}, () => [
          t.button ? (v(), P(u, {
            key: 0,
            ref_key: "btn",
            ref: o,
            class: "p-0 hocus:bg-opacity-10 dark:hocus:bg-white dark:hocus:text-secondary text-secondary dark:text-white",
            type: "text",
            size: "small",
            icon: ge(t.icon || h(Ti)),
            onClick: a
          }, null, 8, ["icon"])) : $("", !0)
        ])
      ], 2);
    };
  }
}, is = {
  ...pa,
  ApColorPicker: Al,
  ApChipTabs: kl,
  ApAvatarItem: Pl,
  ApDropdownMenu: jl,
  ApDropdownItem: zl,
  ApImagePicker: ns,
  ApSiderItem: rs,
  ApSiderTitle: as
}, ls = {
  key: 0,
  class: "h-header md:h-header-md flex-none flex items-center p-4"
}, ss = { class: "flex-grow" }, us = {
  key: 1,
  class: "mt-auto flex-none"
}, cs = {
  __name: "ApSider",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    breakpoint: {
      type: String,
      default: "md"
    },
    clickOutside: {
      type: Boolean,
      default: !0
    },
    fixed: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = qt(), r = tt.useBreakpoint, o = r(), a = e, i = n, l = R(null);
    function u(c) {
      i("update:modelValue", c);
    }
    return Gl(l, () => {
      const c = !o.value[a.breakpoint];
      a.clickOutside && !a.modelValue && c && setTimeout(() => {
        i("update:modelValue", !0);
      }, 100);
    }), (c, d) => {
      const s = M("ap-divider"), f = M("ap-layout-sider");
      return v(), P(f, me(c.$attrs, {
        onBreakpoint: u,
        ref_key: "sider",
        ref: l,
        collapsed: a.modelValue,
        breakpoint: a.breakpoint,
        style: {
          position: e.fixed ? "fixed" : "relative",
          left: 0,
          top: 0,
          bottom: 0
        },
        collapsedWidth: "0",
        class: "bg-sider",
        trigger: null
      }), {
        default: I(() => [
          y("div", {
            class: X(["flex flex-col h-full", {
              "h-screen": a.fixed
            }])
          }, [
            h(t).header ? (v(), E("div", ls, [
              j(c.$slots, "header")
            ])) : $("", !0),
            y("div", ss, [
              h(t).header ? (v(), P(s, {
                key: 0,
                type: "horizontal",
                class: "m-0 w-full"
              })) : $("", !0),
              j(c.$slots, "default")
            ]),
            O(s, {
              type: "horizontal",
              class: "m-0 w-full"
            }),
            h(t).footer ? (v(), E("div", us, [
              j(c.$slots, "footer")
            ])) : $("", !0)
          ], 2)
        ]),
        _: 3
      }, 16, ["collapsed", "breakpoint", "style"]);
    };
  }
}, ds = {
  __name: "ApHeader",
  props: {
    breakpoint: {
      type: String,
      default: "md"
    },
    fixed: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["menu"],
  setup(e, { emit: n }) {
    const t = tt.useBreakpoint(), r = e, o = n;
    function a() {
      o("menu");
    }
    return (i, l) => {
      const u = M("ap-button"), c = M("ap-layout-header"), d = M("ap-divider");
      return v(), E(et, null, [
        O(c, me({
          style: {
            position: e.fixed ? "fixed" : "relative",
            zIndex: 1,
            width: "100%",
            "padding-inline": 0
          },
          class: "flex items-center flex-nowrap h-header md:h-header-md px-4 text-nowrap min-w-fit"
        }, i.$attrs, { ref: "header" }), {
          default: I(() => [
            h(t)[r.breakpoint] ? $("", !0) : (v(), P(u, {
              key: 0,
              class: X("mr-4 w-fit bg-transparent"),
              type: "text",
              default: "",
              icon: ge(h(Ai)),
              onClick: a
            }, null, 8, ["icon"])),
            j(i.$slots, "default")
          ]),
          _: 3
        }, 16, ["style"]),
        O(d, {
          type: "horizontal",
          class: X(["w-full m-0", { "mt-[theme(height.header)] md:mt-[theme(height.header-md)]": e.fixed }])
        }, null, 8, ["class"])
      ], 64);
    };
  }
}, fs = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='74'%20height='79'%20viewBox='0%200%2074%2079'%20fill='none'%3e%3cpath%20d='M17.3398%2037.1797C15.3711%2037.1797%2013.8945%2036.6875%2012.9102%2035.7031C11.944%2034.7188%2011.4609%2033.2057%2011.4609%2031.1641V19.7617C11.4609%2017.7201%2011.944%2016.2161%2012.9102%2015.25C13.8945%2014.2656%2015.3711%2013.7734%2017.3398%2013.7734H28.9609C30.9297%2013.7734%2032.4062%2014.2656%2033.3906%2015.25C34.375%2016.2161%2034.8672%2017.7201%2034.8672%2019.7617V31.1641C34.8672%2033.2057%2034.375%2034.7188%2033.3906%2035.7031C32.4062%2036.6875%2030.9297%2037.1797%2028.9609%2037.1797H17.3398ZM17.2578%2032.832H29.043C29.5352%2032.832%2029.9089%2032.7044%2030.1641%2032.4492C30.4193%2032.194%2030.5469%2031.8112%2030.5469%2031.3008V19.5977C30.5469%2019.0872%2030.4193%2018.7135%2030.1641%2018.4766C29.9089%2018.2214%2029.5352%2018.0938%2029.043%2018.0938H17.2578C16.7656%2018.0938%2016.3919%2018.2214%2016.1367%2018.4766C15.8997%2018.7135%2015.7812%2019.0872%2015.7812%2019.5977V31.3008C15.7812%2031.8112%2015.8997%2032.194%2016.1367%2032.4492C16.3919%2032.7044%2016.7656%2032.832%2017.2578%2032.832ZM20.7031%2028.4844C20.3203%2028.4844%2020.1289%2028.2565%2020.1289%2027.8008V23.0703C20.1289%2022.651%2020.3203%2022.4414%2020.7031%2022.4414H25.5703C25.9714%2022.4414%2026.1719%2022.651%2026.1719%2023.0703V27.8008C26.1719%2028.2565%2025.9714%2028.4844%2025.5703%2028.4844H20.7031ZM45.0117%2037.1797C43.043%2037.1797%2041.5664%2036.6875%2040.582%2035.7031C39.5977%2034.7188%2039.1055%2033.2057%2039.1055%2031.1641V19.7617C39.1055%2017.7201%2039.5977%2016.2161%2040.582%2015.25C41.5664%2014.2656%2043.043%2013.7734%2045.0117%2013.7734H56.6328C58.6016%2013.7734%2060.069%2014.2656%2061.0352%2015.25C62.0195%2016.2161%2062.5117%2017.7201%2062.5117%2019.7617V31.1641C62.5117%2033.2057%2062.0195%2034.7188%2061.0352%2035.7031C60.069%2036.6875%2058.6016%2037.1797%2056.6328%2037.1797H45.0117ZM44.9297%2032.832H56.7148C57.2253%2032.832%2057.599%2032.7044%2057.8359%2032.4492C58.0729%2032.194%2058.1914%2031.8112%2058.1914%2031.3008V19.5977C58.1914%2019.0872%2058.0729%2018.7135%2057.8359%2018.4766C57.599%2018.2214%2057.2253%2018.0938%2056.7148%2018.0938H44.9297C44.4193%2018.0938%2044.0365%2018.2214%2043.7812%2018.4766C43.5443%2018.7135%2043.4258%2019.0872%2043.4258%2019.5977V31.3008C43.4258%2031.8112%2043.5443%2032.194%2043.7812%2032.4492C44.0365%2032.7044%2044.4193%2032.832%2044.9297%2032.832ZM48.4844%2028.4844C48.138%2028.4844%2047.9648%2028.2565%2047.9648%2027.8008V23.0703C47.9648%2022.651%2048.138%2022.4414%2048.4844%2022.4414H53.3789C53.7799%2022.4414%2053.9805%2022.651%2053.9805%2023.0703V27.8008C53.9805%2028.2565%2053.7799%2028.4844%2053.3789%2028.4844H48.4844ZM17.3398%2064.8242C15.3711%2064.8242%2013.8945%2064.332%2012.9102%2063.3477C11.944%2062.3815%2011.4609%2060.8776%2011.4609%2058.8359V47.4062C11.4609%2045.3828%2011.944%2043.8789%2012.9102%2042.8945C13.8945%2041.9102%2015.3711%2041.418%2017.3398%2041.418H28.9609C30.9297%2041.418%2032.4062%2041.9102%2033.3906%2042.8945C34.375%2043.8789%2034.8672%2045.3828%2034.8672%2047.4062V58.8359C34.8672%2060.8776%2034.375%2062.3815%2033.3906%2063.3477C32.4062%2064.332%2030.9297%2064.8242%2028.9609%2064.8242H17.3398ZM17.2578%2060.5039H29.043C29.5352%2060.5039%2029.9089%2060.3763%2030.1641%2060.1211C30.4193%2059.8659%2030.5469%2059.4922%2030.5469%2059V47.2695C30.5469%2046.7591%2030.4193%2046.3763%2030.1641%2046.1211C29.9089%2045.8659%2029.5352%2045.7383%2029.043%2045.7383H17.2578C16.7656%2045.7383%2016.3919%2045.8659%2016.1367%2046.1211C15.8997%2046.3763%2015.7812%2046.7591%2015.7812%2047.2695V59C15.7812%2059.4922%2015.8997%2059.8659%2016.1367%2060.1211C16.3919%2060.3763%2016.7656%2060.5039%2017.2578%2060.5039ZM20.7031%2056.1562C20.3203%2056.1562%2020.1289%2055.9284%2020.1289%2055.4727V50.7422C20.1289%2050.3229%2020.3203%2050.1133%2020.7031%2050.1133H25.5703C25.9714%2050.1133%2026.1719%2050.3229%2026.1719%2050.7422V55.4727C26.1719%2055.9284%2025.9714%2056.1562%2025.5703%2056.1562H20.7031ZM41.0469%2048.7188C40.6641%2048.7188%2040.4727%2048.5%2040.4727%2048.0625V43.332C40.4727%2042.9128%2040.6641%2042.7031%2041.0469%2042.7031H45.9141C46.2969%2042.7031%2046.4883%2042.9128%2046.4883%2043.332V48.0625C46.4883%2048.5%2046.2969%2048.7188%2045.9141%2048.7188H41.0469ZM55.6758%2048.7188C55.293%2048.7188%2055.1016%2048.5%2055.1016%2048.0625V43.332C55.1016%2042.9128%2055.293%2042.7031%2055.6758%2042.7031H60.543C60.9258%2042.7031%2061.1172%2042.9128%2061.1172%2043.332V48.0625C61.1172%2048.5%2060.9258%2048.7188%2060.543%2048.7188H55.6758ZM48.4297%2056.0742C48.0469%2056.0742%2047.8555%2055.8464%2047.8555%2055.3906V50.6602C47.8555%2050.2409%2048.0469%2050.0312%2048.4297%2050.0312H53.2969C53.6797%2050.0312%2053.8711%2050.2409%2053.8711%2050.6602V55.3906C53.8711%2055.8464%2053.6797%2056.0742%2053.2969%2056.0742H48.4297ZM41.0469%2063.375C40.6641%2063.375%2040.4727%2063.1562%2040.4727%2062.7188V57.9609C40.4727%2057.5417%2040.6641%2057.332%2041.0469%2057.332H45.9141C46.2969%2057.332%2046.4883%2057.5417%2046.4883%2057.9609V62.7188C46.4883%2063.1562%2046.2969%2063.375%2045.9141%2063.375H41.0469ZM55.6758%2063.375C55.293%2063.375%2055.1016%2063.1562%2055.1016%2062.7188V57.9609C55.1016%2057.5417%2055.293%2057.332%2055.6758%2057.332H60.543C60.9258%2057.332%2061.1172%2057.5417%2061.1172%2057.9609V62.7188C61.1172%2063.1562%2060.9258%2063.375%2060.543%2063.375H55.6758Z'%20fill='%23121212'%20fill-opacity='0.3'/%3e%3c/svg%3e", ps = {
  key: 0,
  class: "text-base text-xl font-semibold"
}, hs = {
  key: 1,
  class: "text-secondary text-sm text-center font-normal"
}, vs = {
  __name: "ApEmptyState",
  props: {
    image: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    button: {
      type: String
    }
  },
  emits: ["action"],
  setup(e, { emit: n }) {
    const t = n;
    return (r, o) => {
      const a = M("ap-button"), i = M("ap-empty");
      return v(), P(i, {
        image: e.image || h(fs),
        "image-style": {
          height: "80px"
        }
      }, {
        description: I(() => [
          e.title ? (v(), E("div", ps, V(e.title), 1)) : $("", !0),
          e.description ? (v(), E("div", hs, V(e.description), 1)) : $("", !0)
        ]),
        default: I(() => [
          e.button ? (v(), P(a, {
            key: 0,
            size: "large",
            class: "empty-state__button",
            onClick: o[0] || (o[0] = (l) => t("action")),
            type: "primary"
          }, {
            default: I(() => [
              Ie(V(e.button), 1)
            ]),
            _: 1
          })) : $("", !0)
        ]),
        _: 1
      }, 8, ["image"]);
    };
  }
}, gs = {
  ApSider: cs,
  ApHeader: ds,
  ApEmptyState: vs
}, Wt = { ...is, ...gs }, _s = {
  install(e) {
    Object.keys(Wt).forEach((n) => {
      e.component(n, Wt[n]);
    });
  }
};
export {
  As as ATheme,
  xs as ApConfigProvider,
  ks as ApGrid,
  Ss as ApNotification,
  _s as default,
  ys as useTheme
};
